module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0006#rch01"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("CARTOGRAPHY AND DECOLONIZATION")]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_vm._v("Raymond B. Craib")]), _vm._v(" "), _c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "ahaft0101"
    }
  }, [_c('a', {
    staticClass: "page"
  }), _vm._v("I. INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I will begin with a rather plain but instructive map: map 6 from James Francis Horrabin’s "), _c('i', [_vm._v("An Atlas of Empire")]), _vm._v(", published in 1937 (fig 1.1). The map, created and published on the eve of Italy’s invasion of Abyssinia, is a blunt representation of European colonial possessions in Africa. The image reveals visually the following statistic: six European states covering a total area of 660,000 square miles “own[ed] close on 11 and ½ million square miles in Africa.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en1",
      "id": "en1r"
    }
  }, [_vm._v("1")])]), _vm._v(" Such statistics led Horrabin, a working-class educator and innovative socialist geographer, to proffer a remarkably succinct definition of Europe: it was, he wrote, “a group of States holding colonial possessions in other continents.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en2",
      "id": "en2r"
    }
  }, [_vm._v("2")])]), _vm._v(" Two decades later, Frantz Fanon would take this observation to its logical, and historicized, conclusion: “Europe is literally the creation of the Third World.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en3",
      "id": "en3r"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0101"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-akerman-fig01001.jpeg",
      "width": "485"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.1.")]), _vm._v(" Africa possessed. European domination of Africa. Map 6 from J. F. Horrabin, "), _c('i', [_vm._v("An Atlas of Empire")]), _vm._v(" (London: Knopf, 1937).")])]), _vm._v(" "), _c('p', [_vm._v("At their imperial apex, colonial powers (including not only European states but also the United States and Japan) laid claim to more than three-quarters of the world’s landmass. Yet no more than a half-century later this equation had been inverted as anticolonial struggles, domestic agitation in the metropoles, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p12"
    }
  }), _vm._v("an international war against fascism (colonialism’s boomerang effect, in Aimé Césaire’s powerful rendering), and international pressures of various kinds fostered the demise of most forms of colonial rule in most of Africa, Asia, Oceania, and the circum-Caribbean."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en4",
      "id": "en4r"
    }
  }, [_vm._v("4")])]), _vm._v(" One would expect such dramatic political transformations to have serious repercussions in the realm of cartography. Certainly the “military red” of British domination no longer spread itself across the globe. If in 1898 Rand McNally could celebrate the British Empire in an "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p13"
    }
  }), _vm._v("atlas by noting that “the real magnitude of the vast empire of Great Britain can not be fully comprehended until it is studied in a series of GOOD MAPS, such as those contained in this volume,” by the early 1960s even the most ardent imperialists had to recognize that the empire’s sun was indeed setting."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en5",
      "id": "en5r"
    }
  }, [_vm._v("5")])]), _vm._v(" By 1962 Britain’s colonial empire, which had formerly spanned the globe, appeared as little more than a hodgepodge of bloody outposts on the maps of the annual British Colonial Office Lists ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0102"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en6",
      "id": "en6r"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0102"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p14"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "476",
      "src": "images/chi-akerman-fig01002.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.2.")]), _vm._v(" Bloody outposts. Directorate of Overseas Surveys, "), _c('i', [_vm._v("Map of the World")]), _vm._v(". Insert in "), _c('i', [_vm._v("The Colonial Office List, 1962")]), _vm._v(" (London: Her Majesty’s Stationery Office, 1962).")])]), _vm._v(" "), _c('p', [_vm._v("The magnitude of how much had changed in the wake of two world wars and shifts in global resource accumulation can be conveyed with a few statistics: the continent of Africa contained only four independent countries in 1948; by 1965 there were thirty-seven."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en7",
      "id": "en7r"
    }
  }, [_vm._v("7")])]), _vm._v(" The United Nations counted fifty-one member states in 1945; three decades later it had three times that number."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en8",
      "id": "en8r"
    }
  }, [_vm._v("8")])]), _vm._v(" The pace of change was so rapid that the cartographic division for the US National Geographic Society, on its September 1960 atlas plate of Africa, felt compelled to note the following: “Boundaries on this map reflect the political situation as of July 15, 1960, the day the map went to press.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en9",
      "id": "en9r"
    }
  }, [_vm._v("9")])]), _vm._v(" Much had changed. But there were continuities, a reality nowhere better captured than in the fact that theories of neocolonialism developed in tandem with decolonization in the 1960s.")]), _vm._v(" "), _c('p', [_vm._v("In this chapter I take a synoptic view of cartography and decolonization in the twentieth century and make occasional reference to nineteenth-century processes of decolonization in the Americas. The essay is intentionally broad and synthetic: it looks at colonization and decolonization across the globe and across nearly two centuries, although the primary focus is on the twentieth century. While cognizant of the fact that the particularities of decolonization varied according to time and space—something that is clear in the subsequent essays in this volume—I have taken this wide-angle perspective in order to put the historical experiences and processes of decolonization in Africa and Asia, in North America and Latin America, in Oceania and Southwest Asia into conversation, comparison, and relation to one another. Doing so highlights certain patterns and continuities but, of course, at the risk of eliding differences and disjunctures. The essay builds on a growing body of secondary literature on cartography, colonialism, and postcolonialism in order to highlight general themes and points of comparison and contrast, while at the same time plumbing particular primary sources (maps of various kinds) that illustrate such processes or trends. While it highlights certain themes and points, it invariably also suffers from elisions, exceptions, and generalizations. In this respect the essay resembles not only a map—which is inherently selective—but also “decolonization” itself which was, as historian Prasenjit Duara observes, “neither a coherent event [ . . . ] nor a well-defined phenomenon.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en10",
      "id": "en10r"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p15"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _vm._v("The conceptual, as well as geographic, approach to colonialism and decolonization I take here is also somewhat capacious. While my emphasis is on colonialism in the formal sense—that is, formal political control—I do, at certain points and particularly toward the end of the essay, also take up the question of decolonization and neocolonialism or informal empire. My intent is not to conflate what are, and should remain, useful distinctions—between, say, “imperialism” and “colonialism”—regarding forms of external control and/or domination. At the same time, and as will become apparent throughout the essay, such distinctions are rarely clear cut, and some attention to the range of relationships, often unequal and involving a variety of coercive mechanisms, that might be plotted on a “colonial” spectrum is warranted."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en11",
      "id": "en11r"
    }
  }, [_vm._v("11")])]), _vm._v(" “Informal” does not seem adjectively adequate to capture the ruthlessness with which, say, the United States engaged the Caribbean and Central America in the twentieth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en12",
      "id": "en12r"
    }
  }, [_vm._v("12")])]), _vm._v(" But more to the point, informal empire was never far removed from its more heavy-handed partner, which is why when anticolonial leaders, intellectuals, and masses living under the yoke of colonial rule spoke of independence or emancipation, they often did so with a vocabulary informed as much by socialism (and, as I will argue below, anarchism) as by nationalism or anticolonialism per se."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en13",
      "id": "en13r"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', [_vm._v("I wrote this essay as part of a series of talks on mapping the transition from colony to nation, but many colonies did not make such transitions. In a recent grand work on empire, historians Jane Burbank and Fred Cooper observed that nation-states were not the only alternative to empire: federation, confederation, and a host of other possibilities existed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en14",
      "id": "en14r"
    }
  }, [_vm._v("14")])]), _vm._v(" Similarly, historian Jeremy Adelman notes for the specific case of Ibero-America, “no single vision of postcolonial sovereignty filled the vacuum left behind. . . . The nation was not prefigured by colonialism to herald its demise.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en15",
      "id": "en15r"
    }
  }, [_vm._v("15")])]), _vm._v(" Moreover, what exactly independence means is a contentious question. What is the relationship between decolonization and independence? Independence from what? And for whom? And how do such issues manifest themselves in the realm of cartography? To what degree does looking at decolonization through the lens of the history of cartography affect or force us to rethink our understandings of processes of decolonization and vice versa?")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_vm._v("II. LINES, MINDS, AND NAMES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The contours of colonialism still configure the globe."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en16",
      "id": "en16r"
    }
  }, [_vm._v("16")])]), _vm._v(" Decolonization led to the dramatic, and still contentious, partition or territorial reconfiguration of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _vm._v("some formerly colonized lands, most notably in what had been British India and in Southwest Asia. In other cases, colonial territorial configurations outlived their creators. While newly independent states would frequently reconfigure internal jurisdictional boundaries, the international political boundaries inscribed by colonial powers oftentimes remained intact, despite having been imposed arbitrarily, as a matter of administrative convenience, or based upon flawed and ethnocentric principles. Thus, even if they bore little relation to political, social, linguistic, or ecological relationships on the ground, such spatial constructs—and the abbreviated history they carried with them—persisted, both as a consequence of and an impetus for modern cartography."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en17",
      "id": "en17r"
    }
  }, [_vm._v("17")])]), _vm._v(" As geographer Matthew Sparke has aptly noted, “Cartography is part of a reciprocal or, better, a "), _c('i', [_vm._v("recursive")]), _vm._v(" social process in which maps shape a world that in turn shapes its maps.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en18",
      "id": "en18r"
    }
  }, [_vm._v("18")])]), _vm._v(" Thus it was that the membership of the Organization of African Unity, created in 1966, agreed to abide by the boundaries established by the colonial powers in the years following the Berlin Conference of 1885."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en19",
      "id": "en19r"
    }
  }, [_vm._v("19")])]), _vm._v(" Precedent existed in such matters: while the boundaries of many of the fledgling republics of Latin America born of independence movements in the early nineteenth century would change over the course of that century, leaders of those movements initially applied the legal principle of "), _c('i', [_vm._v("uti possidetis juris")]), _vm._v(" (Latin for “as you possess under law”) to ensure that existing colonial contours would serve as the international boundaries for their new states."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en20",
      "id": "en20r"
    }
  }, [_vm._v("20")])]), _vm._v(" Yet those contours—and the criteria used to determine them—were themselves not easily determined or agreed upon, and boundary changes and conflicts were commonplace through much of the nineteenth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en21",
      "id": "en21r"
    }
  }, [_vm._v("21")])]), _vm._v(" Moreover, in many instances the newborn states shared with their Spanish predecessor an inability to assert administrative control beyond the bounds of the centers of political life. To use the possessive when discussing Mexico’s far north or Chile’s or Argentina’s Patagonia is to engage in a useful, but fictional, cartographic shorthand. These were regions where the postcolonial state had little purchase until the arrival of global capital and the development of new transportation and military technologies later in the century.")]), _vm._v(" "), _c('p', [_vm._v("The fact that formerly colonized subjects did not escape the boundaries created by colonial powers does not, of course, mean that newly formed states were somehow inauthentic or colonies in postcolonial drag. Boundaries may be static (and even that is open to debate at some level) but their meanings are not. Regardless of how dramatically they obscured or overwrote other existing territorialities, boundaries created by colonial powers acquired a reality and a meaning over time to many living within their bounds. The intervening decades or centuries between the creation of a colonial territory and its demise "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p18"
    }
  }), _vm._v("were never mere interregnums, nor did the violence of colonialism and the imposition of new property regimes and ethnic identities necessarily prevent colonized subjects from developing affective attachments to new territorialities, new properties, and new identities. Whatever their initial artificiality, the passage of time gave them weight.")]), _vm._v(" "), _c('p', [_vm._v("Thus, while one can readily agree that postcolonial national maps naturalize what are historical and social colonial constructions, it is important to recognize that they do not remain solely ideological and repressive fictions. The anticolonial imaginary was often geographic, and such spaces often constituted what were perceived to be necessary geographies of decolonization. He overstated the case, but writer Albert Memmi was not entirely amiss when he argued that “being oppressed as a group the colonized "), _c('i', [_vm._v("must")]), _vm._v(" necessarily adopt a "), _c('i', [_vm._v("national")]), _vm._v(" and "), _c('i', [_vm._v("ethnic")]), _vm._v(" form of liberation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en22",
      "id": "en22r"
    }
  }, [_vm._v("22")])]), _vm._v(" Not surprisingly, in most cases the national and ethnic form of liberation took shape in part through reference to colonially imposed boundaries. That such was the case highlights the fact that processes of decolonization, like colonization itself, rarely unfolded among equals. At least in the twentieth century, the colonized intelligentsia and the individuals who in many instances led anticolonial movements and/or composed the first generation of postcolonial leadership were often educated in the metropole or by metropolitan teachers, and so the political systems, models, and aspirations they held were often ones associated with the metropole."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en23",
      "id": "en23r"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', [_vm._v("If many postcolonial states did not—and perhaps did not want to—escape the territorial boundaries established by their colonial predecessors, anticolonial leaders and the inheritors of independence could at least decolonize their spaces in other ways, including rewriting the landscape toponymically and recasting the past. Like novels, art, and music, maps became a means through which to re-present and develop a postcolonial identity liberated from colonial determinations. Maps and atlases thus helped perform the hard cultural work of decolonizing the land, the past, and, in the famous phrase of Kenyan intellectual Ngugi wa Thiong’o, the mind."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en24",
      "id": "en24r"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', [_vm._v("Take, for example, the case of toponyms on maps. Decolonization meant that colonizers would no longer dictate the terms of representation: neither politically nor, in this instance, poetically. Naming constituted a basic strategy of imperial and colonial control."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en25",
      "id": "en25r"
    }
  }, [_vm._v("25")])]), _vm._v(" Thus, with decolonization a veritable tide of toponymic change washed much of the globe, at least in the twentieth century. In some cases only the country name changed: British Honduras may now be Belize, but while there one can still travel through Roaring Creek, Bamboo Camp, and Double Head Cabbage. In other cases, new administrations oversaw name changes not only to their nations but also to cities, towns, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _vm._v("districts, streets, and natural features. New names simultaneously overturned those imposed by colonizers and fostered a renewed interest in, and affirmed the validity of, local and regional dialects and national languages. Thus, in many instances spellings, rather than names per se, changed. Whether it be the resuscitation of the hamzah (’) and the macron (ī) in Oceanic place names or the slight modification to Calcutta, a quintessentially colonial city, the idea was to shift language away from an imposed Europeanization. Toponyms and languages matter not solely for the imprint they leave and the impression they make but also for the knowledges they hold, the identities they evoke, the history they convey. Place names are often mnemonic devices that sustain genealogies, ground cultures, and write histories."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en26",
      "id": "en26r"
    }
  }, [_vm._v("26")])]), _vm._v(" In all of these cases, language becomes a key site of anticolonial struggle. As the Irish patriarch in "), _c('i', [_vm._v("Translations")]), _vm._v(", Brian Friel’s remarkable play on the English mapping of Ireland in the 1840s, remarks: “English [ . . . ] couldn’t really express us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en27",
      "id": "en27r"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', [_vm._v("The names applied to regions or nonstate spaces can challenge colonialist frames of reference and further efforts to decolonize not only the mind but the past. Take for example the subtle but powerful difference in perspective that might be evoked by using Oceania or Pacific Islands. Tongan intellectual Epeli Hau‘ofa poignantly noted, “There is a world of difference between viewing the Pacific as ‘islands in a far sea’ and as ‘a sea of islands.’ The first emphasizes dry surfaces in a vast ocean far from the centers of power. . . . The second is a more holistic perspective in which things are seen in the totality of their relationships.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en28",
      "id": "en28r"
    }
  }, [_vm._v("28")])]), _vm._v(" Hau‘ofa’s vision here is emphatically decolonial and cartographic: it is a rethinking of the relation of water, land, and sky and a conceptualization of the space of the ocean itself as connective tissue such that oceanic states no longer appear as small and isolated outposts too remote to achieve economic independence from wealthier nations and too dispersed to meaningfully cohere."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en29",
      "id": "en29r"
    }
  }, [_vm._v("29")])]), _vm._v(" Although it is important to note that indigenous names are not themselves somehow “neutral” in their meaning and representation, Hau‘ofa has history on his side. Many of Oceania’s inhabitants have long traversed and settled swaths of ocean as if they were a liquid prairie. Outrigger canoes—varying in length from nine feet for vessels used in lagoons to thirty feet for double-hulled vehicles with sails intended for long-distance, interisland travel—turn the ocean into a conduit rather than a barrier, a vast plain webbed by routes to island configurations “arranged in blocks or groups rather than widely spaced, isolated specks of land.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en30",
      "id": "en30r"
    }
  }, [_vm._v("30")])]), _vm._v(" Outrigger canoe navigators, orienting themselves through reference to stars and horizon points, sidereal compass technology, and a deeply learned ability to read the ocean and sky, traveled vast distances, in the process establishing fishing and hunting grounds, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("settlements, and trade and communication networks."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en31",
      "id": "en31r"
    }
  }, [_vm._v("31")])]), _vm._v(" Their maps—or stick charts, such as the one shown in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0103"
    }
  }, [_vm._v("figure 1.3")]), _vm._v("—represented patterns of ocean currents and swells in relation to island formations. From this horizontal perspective, the ocean was less a limit or endpoint of a culture or society than a full-fledged part of it, a point captured by none other than navigator and explorer James Cook, who felt compelled to pose the following rhetorical question in his journal in 1778: “How shall we account for this nation spreading itself so far over the Vast ocean?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en32",
      "id": "en32r"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0103"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-akerman-fig01003.jpeg",
      "width": "529"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.3.")]), _vm._v(" Water world. A Marshall Island stick chart for long-distance oceanic canoe voyaging. The chart depicts islands, ocean swells, and currents. Majuro, Marshall Islands, ca. 1920. Made of wood and shells, 67 × 108 cm. Courtesy of Library of Congress Geography and Map Division, Washington, DC.")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v("Cook had already made some effort to learn an answer when he took on board the "), _c('i', [_vm._v("Endeavor")]), _vm._v(" in 1769 a navigator and priest named Tupaia from the island of Raiatea (near Tahiti). Tupaia died while on board but at least a portion of his geographic knowledge was put down on parchment and copies made, including one in the work of Johann Rheingold Forster in his "), _c('i', [_vm._v("Observations Made during a Voyage around the World")]), _vm._v(" (1779) ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0104"
    }
  }, [_vm._v("fig. 1.4")]), _vm._v("). So here is Tupaia’s map . . . or is it? Anthropologist Margaret Jolly captures the quandary well:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Though he is the author, this map is "), _c('i', [_vm._v("not")]), _vm._v(" his indigenous view. We will never know the details of that view, but his vision was likely rather differently “situated knowledge.” I suspect it located the observer not soaring high above the islands, powerfully riding on the confident coordinates of longitude and latitude, plotting a changing global position relative to east and west, north and south, but rather lying low in a canoe, looking up at the heavens, scanning the horizon for signs of land, and navigating the powerful seas with the embodied visual, aural, olfactory, and kinesthetic knowledge passed down "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p22"
    }
  }), _vm._v("through generations of Pacific navigators. His knowledge would have been communicated to other Tahitians through genealogical stories and chants, through the materials of the canoe and the sails, and through the embodied practice of navigation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en33",
      "id": "en33r"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0104"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "611",
      "src": "images/chi-akerman-fig01004.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.4.")]), _vm._v(" Tupaia’s world? The Society Islands, James Cook, from an original chart by Tupaia. The chart is a drawing by Cook based on the information and an initial image made by Tupaia. The scale is impressive: according to David Turnbull, the space represented in the map here is approximately the size of the continental United States.")])]), _vm._v(" "), _c('p', [_vm._v("The point here is not to argue over whether Tupaia did or did not create the map but rather to emphasize that Hau‘ofa’s “Oceania” asks us to acknowledge—historically and linguistically—such theoretical and practical knowledge, not as a means to articulate radical difference but in order to move beyond colonial legacies that have cast “a nation spread over a vast ocean” as little more than isolated and distant relations stranded on "), _c('i', [_vm._v("tierra firme")]), _vm._v(" . . . as little more than so many “Pacific Islands.”")]), _vm._v(" "), _c('p', [_vm._v("As well as place names, postcolonial administrations and populations have produced maps and atlases—national, cultural, and political—as part of a broader effort to connect a place to a past. They helped foster (whether as resurrection or invention) a nationalist historical narrative. Cartographers in places diverse as Mexico, Thailand, Turkey, and Iran inscribed—and reinscribed—a distant past onto modern maps of the nation in an effort to stress the nation’s temporal longevity and cultural coherence, or to visualize and legitimize irredentist aims."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en34",
      "id": "en34r"
    }
  }, [_vm._v("34")])]), _vm._v(" Similarly, Indian intellectuals in turn-of-the-century British India recast the map of the colony as a female adorned with archaic and culturally specific items in order to link history and geography and thereby “foster the sentiment of belonging and possession.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en35",
      "id": "en35r"
    }
  }, [_vm._v("35")])]), _vm._v(" More recently, players for the Chilean soccer club Palestino—founded by Palestinian immigrants in 1920—sport not only jerseys with the colors of the Palestinian flag, but also numbers on their shirts in which, controversially, the “one” is in the shape of Palestine’s geographic configuration prior to the creation of Israel.")]), _vm._v(" "), _c('p', [_vm._v("By the mid-twentieth century such efforts were often pursued through the production of national atlases, what geographer Mark Monmonier has called the “symbol of national unity, scientific achievement, and political independence” par excellence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en36",
      "id": "en36r"
    }
  }, [_vm._v("36")])]), _vm._v(" Atlases served as a powerful means of cultural and political self-representation. Frequently designed for broad public consumption and reflecting concerted efforts to inculcate a particular image of a place and its past in order to forge collective unity, national atlases combined modern technological forms and formats with attention to cultural specificity and particularity. Thus atlases would often celebrate (or, at times, idealize) pasts that preceeded the colonial era, narrating how the country took shape beyond the confines of colonialism.")]), _vm._v(" "), _c('p', [_vm._v("These creations frequently carry with them the specter of invented tradition."), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p23"
    }
  }), _vm._v(" As historian Jeremy Black has noted, they can suffer from a “habit of seeking to portray the long-term history of states whose territorial extent and ethnic composition were often the work of European conquerors and therefore relatively recent.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en37",
      "id": "en37r"
    }
  }, [_vm._v("37")])]), _vm._v(" As important a point as this is, some caution is warranted here. For one, we should not too quickly jump to the conclusion that always everywhere Europeans made colonial boundaries and affiliations while their subjects merely watched. Subjects they may have been; passive they were not. Second, such an argument might be taken to mean that therefore these efforts at decolonial history and place making are somehow contrived. Well . . . yes, but the whiff of artifice lingers around all nation-states, regardless of their purported longevity. In fact, one might suggest a corollary: the more ancient a past claimed, the stronger the smell. Third, such a perspective tends to forget that the formation of modern European states often unfolded in relation to colonial expansion, to the degree that one might argue that the nation-states of Europe were in fact at least partially a product of the colonies. And finally, there "), _c('i', [_vm._v("was")]), _vm._v(" a past (a history, if not History) prior to the arrival of the colonials. In the aftermath of decades or generations of colonial rule, how does one write that past? More to the point, how does one write such pasts—violently occluded, suppressed, or ignored by colonizers—in deeply political and persistently neocolonial contexts? On what space do such pasts get to unfold? The very creation of such nationalist pasts—of Histories that locate recent states deep in time—was in part an effort to situate the colonized in historical time; an effort to respond to, and overcome, colonizers’ models of the world that had cast the colonized as essentially timeless and premodern."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en38",
      "id": "en38r"
    }
  }, [_vm._v("38")])]), _vm._v(" Rather than anachronistic and essentialist projections, such historical geographies might more productively be seen as simultaneous efforts to account for those neglected pasts and to engage in a dialectical process of cultural recreation in the wake of generations of colonial rule and cultural, social, and political oppression."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en39",
      "id": "en39r"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_vm._v("III. OCCUPIED: INTERNAL COLONIALISM")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The more troubling aspect of such efforts is not their supposed historical and spatial infidelities. It is, rather, their potential for social and political exclusion. Who wields such visions of the past and to what end? Decolonization did not necessarily entail political, social, or cultural equality for all those living within a given empire’s or nation-state’s bounds. Leaders of anticolonial movements could be more intent on protecting and perpetuating the interests of a particular class or sector of society than on implementing broad social change. In this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p24"
    }
  }), _vm._v("they shared the experience of European elites who, during and after the French Revolution, used notions of national sovereignty largely as a means to hold on to their status."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en40",
      "id": "en40r"
    }
  }, [_vm._v("40")])]), _vm._v(" Other examples abound, from Lat Dior and his Wolof kingdom in Senegal to the political powers in postcolonial Vanuatu to the marginalization of Berber speakers in northwest Africa."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en41",
      "id": "en41r"
    }
  }, [_vm._v("41")])]), _vm._v(" Or take the Creole elite who garnered independence from Spain in early nineteenth century Latin America, men such as Agustín de Iturbide; some have argued that they can hardly have been considered colonial subjects and that the transition from Spanish to national rule heralded little change for the majority of the indigenous and poor mestizo inhabitants."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en42",
      "id": "en42r"
    }
  }, [_vm._v("42")])]), _vm._v(" A significant number of the anti-imperialists in Cuba and Puerto Rico who sought liberation from Spanish rule still held dreams of a nation purged of blacks."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en43",
      "id": "en43r"
    }
  }, [_vm._v("43")])]), _vm._v(" And lest we forget, the Age of Liberty was also the Age of Slavery. In the United States liberation from imperial rule perpetuated slavery rather than hastened its demise: remaining British colonies would abolish slavery some three decades prior to its end in the United States."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en44",
      "id": "en44r"
    }
  }, [_vm._v("44")])]), _vm._v(" Such lessons were not lost on Frantz Fanon, who, a century later, would strike an angry and suspicious tone when envisioning Algerian and African independence: “The changeover will not take place at the level of the structures set up by the [national] bourgeoisie during its reign, since that caste has done nothing more than take over unchanged the legacy of the economy, the thought, and the institutions left by the colonialists.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en45",
      "id": "en45r"
    }
  }, [_vm._v("45")])]), _vm._v(" At the expense of the majority of the populace, they “inherit the unfair advantages which are a legacy of the colonial period.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en46",
      "id": "en46r"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', [_vm._v("Clearly there were changes in the shift from colonial to independent rule. In most of Latin America, formal caste distinctions disappeared; in the wake of the ravages of a decade of wars, new opportunities arose for peasants and Indians (often one in the same) to regain or expand landholding; slavery was abolished, as early as the 1820s in some areas, and by the 1850s in all countries except Brazil and Cuba. Even so, for the mass of working people, urban and rural, there was often limited change in the social hierarchy after independence. We might speak of independence for particular polities, but for many inhabitants of former colonies this did not necessarily translate into self-rule. Similarly, for long-marginalized ethnic, cultural, and linguistic minorities, the transfer from colonial to national rule could appear as no transfer at all, being little more than a shift from external to internal colonialism. The Creole elites of much of Spanish America may have celebrated their nations’ native pasts, as Mexican cartographer Antonio García Cubas did here in an 1885 plate from his "), _c('i', [_vm._v("Atlas")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0105"
    }
  }, [_vm._v("fig. 1.5")]), _vm._v("), but they seemed to be, at best, at a loss when it came to their "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p25"
    }
  }), _vm._v("indigenous contemporaries."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en47",
      "id": "en47r"
    }
  }, [_vm._v("47")])]), _vm._v(" The Mapuche of Chile and the native peoples of Argentina’s Patagonia and Chaco regions all confronted expansionist states in the late nineteenth century that, allied with international capital, were arguably just as rapacious and ruthless as their colonial predecessor, if not more. The same could be said regarding the struggle for sovereignty in what became the United States.")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0105"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "711",
      "src": "images/chi-akerman-fig01005.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.5.")]), _vm._v(" Distant Indians. Antonio García Cubas, “Carta histórica y arqueológica,” from his "), _c('i', [_vm._v("Atlas pintoresco e histórico de los Estados Unidos Mexicanos")]), _vm._v(" (México City: Debray, 1885). The map is surrounded by illustrations of a number of prominent archaeological sites as well as objects from Mexico’s National Museum. Image courtesy of David Rumsey Map Collection ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.davidrumsey.com",
      "target": "_blank"
    }
  }, [_vm._v("www.davidrumsey.com")]), _vm._v(").")])]), _vm._v(" "), _c('p', [_vm._v("In the twentieth century, similar cases abound: take, for example, South Africa, where members of the minority white population created atlases that purported to represent the whole country even as the regime of apartheid "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p26"
    }
  }), _vm._v("found its fullest expression."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en48",
      "id": "en48r"
    }
  }, [_vm._v("48")])]), _vm._v(" The Portuguese colony of East Timor declared independence in late November 1975; in December of that same year, Indonesian forces invaded. The Bougainville Rebellion of 1988 pitted an armed insurgency seeking independence against the military forces of Papua New Guinea, itself only recently liberated from Australian rule in 1975. Ethiopia’s annexation of Eritrea in 1962 ushered in language and educational policies that smacked of old colonial habits to many Eritreans. The decades-long war that followed eventually ended with recognition of Eritrean independence in 1993. In Sudan the three southernmost provinces were home to a missionary-educated elite cultivated by British colonial machinations that sought to “retribalize” Sudan. This elite found itself with little access to the state and rebelled against the Khartoum-based government at the very moment of Sudanese independence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en49",
      "id": "en49r"
    }
  }, [_vm._v("49")])]), _vm._v(" The simultaneous persistence and reworking of colonial technologies, epistemologies, and categories of difference is captured vividly in a 1969 map, a sheet of which is shown in figures "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0106a"
    }
  }, [_vm._v("1.6a")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0106b"
    }
  }, [_vm._v("1.6b")]), _vm._v(". The Sudanese authorities took a 1946 British colonial map of tribal and provincial boundaries and reinscribed it thickly with racial categories and boundaries. The Sudanese Survey Department labeled those groups of the southern provinces, still resisting Khartoum, as “Negroid,” and those in the remaining provinces, with two exceptions, as “Arabic.” One of those exceptions was Darfur, the populace of which the Survey Department categorized as “Negroid” but situated within an administrative space deemed “Arabic.”")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0106a"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "578",
      "src": "images/chi-akerman-fig01006a.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.6a.")]), _vm._v(" A new Sudan? This sheet shows the southernmost areas of Sudan with the racialized boundary marker. Sudan Survey Department, "), _c('i', [_vm._v("Sudan: Tribes, Sheets 1–3")]), _vm._v(". 1:2,000,000. Khartoum: Sudan Survey Department, October 1946, corrected 1969. Courtesy of Map Collection, Olin Library, Cornell University.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0106b"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "189",
      "src": "images/chi-akerman-fig01006b.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.6b.")]), _vm._v("(detail). Sudanese legends. The legend shows the categories used for boundaries on the postcolonial map.")])]), _vm._v(" "), _c('p', [_vm._v("The intricacies of such anticolonial movements around the globe during the 1950s and 1960s inspired marginalized populations in countries that had long since been formally decolonized, including the United States. This should hardly come as a surprise: were the differences between the racial hierarchies that held sway in many colonies and the virulent Jim Crow laws in the United States really that marked?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en50",
      "id": "en50r"
    }
  }, [_vm._v("50")])]), _vm._v(" Thus, by the 1950s and 1960s, in the midst of a “cold war,” black militants in the United States questioned the narrative teleology of “freedom” proffered by a nominally liberal state that still tolerated segregation and racial violence; instead, they found inspiration in the racial tolerance purportedly advocated by Soviet Russia. The equation of social justice with racial justice—of the intimate link between racial and class prejudice—explains Stokely Carmichael’s appreciation of Fidel Castro as “the blackest man in the Caribbean.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en51",
      "id": "en51r"
    }
  }, [_vm._v("51")])]), _vm._v(" Meanwhile, in the late 1960s and 1970s, Chicano nationalists spoke of “internal colonialism” and identified Aztlán as the ancestral homeland of the Aztecs and, therefore, as the ancestral home of people of Mexican descent living in, as Rudolfo Acuña provocatively phrased it, an “occupied America” (figs. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0107"
    }
  }, [_vm._v("1.7")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0108"
    }
  }, [_vm._v("1.8")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en52",
      "id": "en52r"
    }
  }, [_vm._v("52")])]), _vm._v(" They needed no further explanation "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p27"
    }
  }), _vm._v("when philosopher Jean-Paul Sartre wrote that Americans (by which he meant the United States) “have their colonies ‘at home’ in their own country,” or when educational theorist Paulo Freire, after teaching and living in the United States, explained that “third world” was a political rather than geographic category."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en53",
      "id": "en53r"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0107"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "400",
      "src": "images/chi-akerman-fig01007.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.7.")]), _vm._v(" Occupied ground. Emilio Aguayo, "), _c('i', [_vm._v("Somos Aztlán")]), _vm._v(". Mural at the Seattle Ethnic Cultural Center. The contemporary boundaries of the states of California, Arizona, Colorado, New Mexico, and Texas are highlighted and then overwritten with the words “somos Aztlán” (“We are Aztlán”), while descendents of Aztlán confront “The Society,” draped in a white cloak reminiscent of the Ku Klux Klan and wielding a scythe of racism and oppression. Courtesy of Oscar Rosales Castañeda. Photograph by Oscar Rosales Castañeda. Reproduced with permission.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0108"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "701",
      "src": "images/chi-akerman-fig01008.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.8.")]), _vm._v(" Return. Gilbert (Magu) Sánchez Luján, "), _c('i', [_vm._v("Trailing los Antepasados")]), _vm._v(" (2000). The artist positions the globe with South America at the top, a reversal mirrored in the reverse migration of Mexican migrants to the mythical homeland of Aztlán. In Virginia M. Fields and Victor Zamudio-Taylor, eds., "), _c('i', [_vm._v("The Road to Aztlan: Art from a Mythic Homeland")]), _vm._v(" (Los Angeles: Los Angeles County Museum of Art, 2001), 18. Reproduced with the kind permission of Otoño Luján.")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p28"
    }
  }), _vm._v("IV. AN EMPIRE OF NATION-STATES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("All of this raises a question: To what degree is the nation-state itself a perpetuation, rather than supercession, of colonialism? A “poisoned gift,” as Michael Hardt and Antonio Negri put it?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en54",
      "id": "en54r"
    }
  }, [_vm._v("54")])]), _vm._v(" As numerous authors have observed, the nation-state form was not necessarily the only—or primary—option for anticolonial movements. Yet too frequently, as Fred Cooper notes, “because we know that the politics of the 1940s and 1950s did indeed end up producing nation-states, we tend to weave all forms of opposition to what colonialism did into a narrative of growing nationalist sentiment and nationalist organization. That the motivations and even the effects of political action at several junctures could have been something else can easily be lost.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en55",
      "id": "en55r"
    }
  }, [_vm._v("55")])]), _vm._v(" Scholars have made similar arguments for insurgent politics in nineteenth-century Latin America."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en56",
      "id": "en56r"
    }
  }, [_vm._v("56")])]), _vm._v(" Lost are the alternative political possibilities that circulated that did not take the liberal state as their starting and ending point. Indeed, simultaneous with late nineteenth-century anticolonial struggles a remarkable, cosmopolitan, and transnational movement opposed to the imperialism of both colonial "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p29"
    }
  }), _vm._v("states and nation-states reached its apex: anarchism. The most important leftist movement of the era, anarchism was the primary oppositional force challenging capitalism, imperialism, oligarchy, and autocracy, and it linked anticolonial leaders across hemispheres, from Manila to Havana, from Cairo to Bengal, from Edo to Moscow."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en57",
      "id": "en57r"
    }
  }, [_vm._v("57")])]), _vm._v(" Anarchism would confront opposition from both the left and the right as the twentieth century progressed, particularly by the 1930s, and not surprisingly so given the devotion of both liberals and communists to the nation-state.")]), _vm._v(" "), _c('p', [_vm._v("Thus, nationalism—at times, but certainly not always, a virulent ethnonationalism—often emerged as the counter to colonial rule. New forms—domestic forms, for lack of a better word—of colonialism arose, ones that sought to force “an isomorphism between national populations and territorial domains.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en58",
      "id": "en58r"
    }
  }, [_vm._v("58")])]), _vm._v(" New minoritized populations were created; others persisted through the transfer of power. This meant for many already marginalized, or newly marginalized, populations that the nation-state appeared on the horizon "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p30"
    }
  }), _vm._v("as little more than another form of labor capture, cultural repression, resource exploitation, and territorial expropriation. James Scott argues:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("the encounter between expansionary states and self-governing peoples [that occurred in Southeast Asia] . . . is echoed in the cultural and administrative process of “internal colonialism” that characterizes the formation of most modern Western nation-states; in the imperial projects of the Romans, the Hapsburgs, the Ottomans, the Han, and the British; in the subjugation of indigenous peoples in “white-settler” colonies such as the United States, Canada, South Africa, Australia, and Algeria; in the dialectic between sedentary, town-dwelling Arabs and nomadic pastoralists that have characterized much of Middle Eastern history."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en59",
      "id": "en59r"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In such cases, the nation-state appears as a form of colonial persistence, a perpetuation of, rather than emancipation from, colonial ontologies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en60",
      "id": "en60r"
    }
  }, [_vm._v("60")])]), _vm._v(" Indeed, in certain cases one would be hard pressed to find the difference between colonial and national cartographic techniques and the manner in which they were applied, particularly in relation to long-marginalized populations whose relationships to any state form—whether colonial or national—were invariably conflictual and unequal."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en61",
      "id": "en61r"
    }
  }, [_vm._v("61")])]), _vm._v(" Historian Jeremy Black, one of the few writers to have attempted to wrestle broadly with decolonization and cartography, writes that “the cartographic processes and devices employed elsewhere in the world are very much those of the West. Western science and techniques remain central, and there has been no real attempt to revive or devise different cartographic methods.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en62",
      "id": "en62r"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', [_vm._v("I am sympathetic to Black’s point—indeed, it goes to the heart of both the loose abstraction and brute materiality of colonialism, and I will pursue its implications in a moment—but it does require at least some qualification. It is worth recalling, for one, that the technologies used by colonizing powers did not necessarily develop prior to, or in isolation from, acts of colonization and the activities of the colonized themselves. Claims of technological diffusion—that located the origins and development of “science” in the metropole—were (and remain) integral components of self-serving colonial ideologies that emphasized “difference” in order to legitimate subjugation, despite the fact that such “differences” were produced through, rather than prior to, colonial relations. (Indeed, such claims were essential components to the very constitution—the very fabrication—of something called “the West.”) These were retrospective claims that suppressed the realm of interchange, overlap, and reciprocal interaction—the entire world of dialogic, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p31"
    }
  }), _vm._v("transcultural engagement—that characterized how colonial science often functioned and developed on the ground."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en63",
      "id": "en63r"
    }
  }, [_vm._v("63")])]), _vm._v(" Colonial cartographic routines drew upon local practices, knowledges, and mapping operations; meanwhile, colonized peoples participated in mapping enterprises and populated cartographic bureaucracies, as agronomists, as surveyors and draftsmen, as informants and guides, and in a multitude of other roles."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en64",
      "id": "en64r"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', [_vm._v("Indeed, this helps to explain to some degree the remarkable continuities in colonial and postcolonial cartographic technologies, practices, personnel, and modes of representation. Postcolonial governments around the globe often took the cadastral, geodetic, and topographic surveys of previous colonial administrations and put them to use for new political and social programs. Continuities in personnel were common also, whether it be in the composition of survey crews in postrevolutionary Mexico or in postcolonial Ghana."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en65",
      "id": "en65r"
    }
  }, [_vm._v("65")])]), _vm._v(" In Nigeria, Northern Rhodesia/Zambia, and Swaziland, the British Directorate of Overseas Surveys continued working on large-scale topographic surveys after independence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en66",
      "id": "en66r"
    }
  }, [_vm._v("66")])]), _vm._v(" This should not be surprising. The same technologies and skills that went into generating colonial boundaries or creating settler properties were used to affirm postcolonial boundaries, to expropriate or confirm properties, or to undertake vast programs of land reform."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en67",
      "id": "en67r"
    }
  }, [_vm._v("67")])]), _vm._v(" While such reforms were not always necessarily associated with formal decolonization, they were often part of a larger set of initiatives undertaken by many young (and some not so young) governments to assert power and ownership over national assets and to fulfill the promise of self-determination and sovereignty. This was as true for, say, postrevolutionary Mexico or Bolivia—long independent from formal colonial rule—as it was for only recently liberated Nigeria or Tanzania.")]), _vm._v(" "), _c('p', [_vm._v("Colonial cartographic technologies, regardless of purported origin, could be used for myriad purposes. Technologies were rife with subversive possibility. Kingdoms, states, and populaces could, and did, appropriate various mapping technologies associated with colonizing powers to their own ends—in some cases to stave off colonial encroachments, in other cases to expand their own territorial bounds, and yet in other instances to defend highly localized forms of land tenure or sovereignty. In other cases such technologies were used to visually represent an alternative nationalist imagination to that plotted out by both colonial and postcolonial regimes, as Sumathi Ramaswamy has demonstrated for the case of Lemuria, or to purport historical or legal territorial rights, as seen in the Lakota logo-map shown in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0109"
    }
  }, [_vm._v("figure 1.9")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en68",
      "id": "en68r"
    }
  }, [_vm._v("68")])]), _vm._v(" Although such technological and epistemological appropriations (forced appropriations, perhaps) could be cast as part of a narrative of loss, a shift in perspective might suggest we see them as, in Ramaswamy’s felicitous phrasing, “hijackings,” a term "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p32"
    }
  }), _vm._v("that draws our attention to the dialogic and politically empowering manner in which such technologies and epistemologies can be used."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en69",
      "id": "en69r"
    }
  }, [_vm._v("69")])]), _vm._v(" Rather than being passively infiltrated, colonized subjects here become active agents and historical subjects."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en70",
      "id": "en70r"
    }
  }, [_vm._v("70")])]), _vm._v(" And, if one is to take the recent arguments of Kapil Raj to their logical conclusion, we might similarly argue that the British in certain cases hijacked methods and theories from their soon-to-be colonial subjects."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en71",
      "id": "en71r"
    }
  }, [_vm._v("71")])]), _vm._v(" There is, then, a dialectic—epistemologically, technologically, and artistically—at work that makes it difficult to narrate the history of cartography as a story solely of domination and resistance.")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0109"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "208",
      "src": "images/chi-akerman-fig01009.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.9.")]), _vm._v(" Hijackings. Lakota logo-map, by the Black Hills Alliance of South Dakota. This illustration comes from a lapel button and is meant to visually emphasize the size and boundaries of territory promised the Sioux in the 1868 Ft. Laramie Treaty. Courtesy of Zoltán Grossman.")])]), _vm._v(" "), _c('p', [_vm._v("Having said that, colonialism was never a relationship of equals, and the power imbalances cannot be ignored. Strategies of cartographic appropriation, as geographers Joel Wainwright and Joe Bryan have argued, “do not reverse colonial social relations so much as rework them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en72",
      "id": "en72r"
    }
  }, [_vm._v("72")])]), _vm._v(" Colonized populations found themselves in situations in which they had little choice but to engage to some degree with the idiom of the state and its emphasis on property and contract, thus becoming physically and epistemologically enclosed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en73",
      "id": "en73r"
    }
  }, [_vm._v("73")])]), _vm._v(" Cartographic technologies may have been useful in carrying out radical land reform programs, for example, but the basic premises of modern land surveying left little room for forms of engaging with the land that did not conform to the specifics of nominally Western property norms. Different ways of understanding, occupying, and working space were made to disappear—largely through the law—and different ways of representing space dismissed in courts as unscientific, unreliable, or simply illegible. For example, connections to and tenure in land among some aboriginal peoples of Australia is expressed and determined through “knowledge of dreamings,” in which “stories, songs, dances and sacred objects relating to the dreamings are the very title deeds. [ . . . ] In contrast with the commodity view of rights to land, an Aboriginal person’s rights to land are not capable of being bought and sold, because the self cannot"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p33"
    }
  }), _vm._v(" be traded.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en74",
      "id": "en74r"
    }
  }, [_vm._v("74")])]), _vm._v(" Or take the case brought to court in 1987 by the Gitksan and Wet’suwet’en peoples in the Canadian province of British Columbia, regarding issues of self-government and territorial jurisdiction, in which they drew on very different conceptualizations and practices of space and cartography from that proffered by the Canadian state."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en75",
      "id": "en75r"
    }
  }, [_vm._v("75")])]), _vm._v(" They used oral traditions and songs as a means to evoke a historical geography. Both in form and content these challenged the standard and imposed criteria for geographic and historical evidence followed by the court."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en76",
      "id": "en76r"
    }
  }, [_vm._v("76")])]), _vm._v(" Their efforts were initially not successful, revealing the difficulties faced by populations attempting to challenge colonialism’s legacies outside of its own epistemological formations ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0110"
    }
  }, [_vm._v("fig. 1.10")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0110"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p34"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-akerman-fig01010.jpeg",
      "width": "467"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.10.")]), _vm._v(" Song spaces. “The Law vs. Ayook: Written vs. Oral History.” Don Monet shows competing epistemologies in a case pitting First Nations peoples against the Canadian government. The elders are singing or chanting their community’s territoriality while tomes of texts and topographic maps sit between them and the judge. From Don Monet and Skanu’u, "), _c('i', [_vm._v("Colonialism on Trial")]), _vm._v(": "), _c('i', [_vm._v("Indigenous Land Rights and the Gitksan and Wet’suwet’en Sovereignty Case")]), _vm._v(" (Philadelphia: New Society Publishers, 1991), 41. Copyright Don Monet. Reproduced with permission.")])]), _vm._v(" "), _c('p', [_vm._v("Thus, as Curtis Berkey notes, “the challenge for Native peoples and their lawyers is to develop maps that incorporate traditional ways of knowing, while at the same time adhering to cartographic procedures that are acceptable in an alien legal system. In this way, courts may be persuaded that the truth contained in Native maps is worthy of the same respect as the official maps of the government.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en77",
      "id": "en77r"
    }
  }, [_vm._v("77")])]), _vm._v(" Participatory and community mapping projects, at times controversial, have highlighted both the promise and problem of trying to navigate through one of the most persistent realities of colonialism: that colonizers unequally set the terms of ontological and epistemological engagement."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en78",
      "id": "en78r"
    }
  }, [_vm._v("78")])]), _vm._v(" Such projects can simultaneously confront and challenge colonial logics and generate a dialogue between tradition and modernity, among the past, present, and future—factors that are an integral part of any collectivity. “By definition,” writes Joe Bryan with respect to participatory community mapping, “maps present indigenous traditions in new ways, to new audiences, creating new understandings of community and territory.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en79",
      "id": "en79r"
    }
  }, [_vm._v("79")])]), _vm._v(" The point is essential if we are to move beyond stale arguments that celebrate stasis as the sine qua non of authenticity. Holding “culture” or “custom” in a state of stasis is no less a colonial view. The question of “custom” is never outside the political context in which it is invoked. This is not to suggest it is deployed purely instrumentally but that “custom,” much like “modernity,” is a relational and contextual concept."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en80",
      "id": "en80r"
    }
  }, [_vm._v("80")])]), _vm._v(" More bluntly, determining what is native and what is foreign is always a fraught—that is to say, political—exercise. Thus, instead of equating the authentic with the pure or unsullied, a strategy of conservative enclosure if there ever was one, or, conversely, suggesting no such thing as authenticity is possible, we might instead think about authenticity in the terms eloquently laid out by anthropologist Sherry Ortner:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Authenticity is another highly problematized term, insofar as it seems to presume a naïve belief in cultural purity, in untouched cultures whose histories "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p35"
    }
  }), _vm._v("are uncontaminated by those of their neighbors or of the west. I make no such presumptions; nonetheless, there must be a way to talk about what the Comaroffs call “the endogenous historicity of local worlds” [ . . . ] in which the pieces of reality, however much borrowed from or imposed by others, are woven together through the logic of a group’s own locally or historically evolved bricolage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en81",
      "id": "en81r"
    }
  }, [_vm._v("81")])])])]), _vm._v(" "), _c('p', [_vm._v("Such a perspective is useful in avoiding the pitfalls of a static and romanticized ethnocentrism (what Michael Watts has trenchantly critiqued as the romance of community) that obsesses over spatial fixity rather than mobility and separation rather than connection."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en82",
      "id": "en82r"
    }
  }, [_vm._v("82")])]), _vm._v(" Rather than lamenting change with an implicit narrative of decline, such an understanding of authenticity works to wrestle with the constant struggle between continuity and change, how it unfolds, and on whose terms. It situates the colonized as subjects and agents of their own history, as active participants in historical time. Jon Parmenter captures the stakes:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Persistent conceptions of early American space as a surface upon which Europeans acted and Native peoples reacted have yielded narratives that obscure the contemporaneous temporalities and heterogeneities of space for non-European actors. Such accounts fail to acknowledge the coeval yet vastly different experience of the Iroquois (and other indigenous) peoples. Subordinated to the self-producing narrative of the emergence of the United States, the Iroquois have been denied their own historical trajectories and effectively (though artificially) held still while others have done the moving."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en83",
      "id": "en83r"
    }
  }, [_vm._v("83")])])])]), _vm._v(" "), _c('p', [_vm._v("As well as being held historically still, so too have non-European actors been held geographically still. For example, despite the fact that Oceania inhabitants were (and are) quite mobile, in the historiography it is the Europeans who do the moving and the Oceania natives who stay in place."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en84",
      "id": "en84r"
    }
  }, [_vm._v("84")])]), _vm._v(" Movement on their part tends to be read as an indicator of declension, not expansion. It is recognizable state actors who occupy center stage, who move historically and geographically, who act: “the” British, “the” Spanish, “the” French, and so forth. The inexorable logic of manifest destiny leaves little room for nonstate spaces or different imperial spaces. Yet postcontact “indigenous imperialism” is hardly an oxymoron. The Sioux were a dominant power in the northern plains for much of the nineteenth-century, asserting control over spaces where others also lived (the Pawnee, Ponca, Otoe, and Omaha, among others)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en85",
      "id": "en85r"
    }
  }, [_vm._v("85")])]), _vm._v(" Thus, one might look at the Black Hills Alliance logo-map shown above "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p36"
    }
  }), _vm._v("as simultaneously—and not paradoxically—an imperial and anti-imperial representation. Or take Pekka Hamalainen’s recent, trenchant study, which shows in compelling detail how it was in fact the Comanche who were the dominant empire of the south-central plains of North America in the eighteenth and nineteenth centuries, not the European settlers. In a form of what he calls “reverse colonialism,” the Comanche from the period 1750 to 1850 were able to “expand, dictate and prosper, and European colonists [forced to] resist, retreat and struggle to survive.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en86",
      "id": "en86r"
    }
  }, [_vm._v("86")])]), _vm._v(" Hence the need for a map of a place of which few have heard: “la Comanchería” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0111"
    }
  }, [_vm._v("fig. 1.11")]), _vm._v("). Whether because they were fixated on the birth of nations, mired in exceptionalist extravaganzas, or obsessed with the fetishizing of cultural difference, historians have ignored the possibilities that indigenous polities could be imperial, powerful, political—in a word, human—and shape in proactive ways the modern history of North America. In effect, the past has been colonized by an empire of nation-states."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en87",
      "id": "en87r"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0111"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "900",
      "src": "images/chi-akerman-fig01011.jpg",
      "width": "642"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.11.")]), _vm._v(" Indigenous empire. La Comanchería, from Hamalainen, "), _c('i', [_vm._v("The Comanche Empire")]), _vm._v(" (New Haven: Yale University Press, 2008). Reproduced with permission of Yale University Press.")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("V. FIVE-SIXTHS OF THE WORLD")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Has the present, too, been in some sense colonized by the nation-state? To what degree has the understanding of the nation-state as the antithesis of the colonial state masked a reworking of, rather than an end to, imperial relations? Let me return again to the work of J. F. Horrabin, who, writing in 1937, captured the dilemma succinctly:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Modern imperialism . . . does not always proceed by the method of armed conquest and annexation of territory. It has discovered that economic “penetration,” leaving the political independence of the penetrated country nominally intact, is occasionally sufficient for its purposes. In a very real sense, therefore . . . such “penetrated” (and dependent) countries may be accounted colonial possessions of other states. But to have included all these in our catalogue would have been to map "), _c('i', [_vm._v("five-sixths of the world")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en88",
      "id": "en88r"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('p', [_vm._v("I share Horrabin’s frustrations. Exactly where to draw the line in examining colonialism and its purported demise is not easy. To expand the definition too far is to make the very concept of “decolonization” analytically anemic. It is to also risk conflating different forms of imperialism and subsequent forms of decolonization. At the same time, to limit the discussion to "), _c('i', [_vm._v("political")]), _vm._v(" independence—and the transition from formal colonial status to formal "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p37"
    }
  }), _vm._v("nation-state status—would be intellectually naive and conceptually dubious. It would be, in the pithy words of the authors of a classic statement on the problem, “like judging the size and character of icebergs solely from the parts above the water-line.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en89",
      "id": "en89r"
    }
  }, [_vm._v("89")])]), _vm._v(" Independence and decolonization are not necessarily the same thing, and all too often decolonization could take shape as largely "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p38"
    }
  }), _vm._v("a rearticulation of forms of dependence: that is to say, of forms of colonial power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en90",
      "id": "en90r"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', [_vm._v("Even the claim of political independence raises questions. After all, colonial holdings were never homogeneously administered or defined. There were “repertoires of imperial power”: dominions, commonwealths, and protectorates were all imperial designations that, to varying degrees, sought to blend subordination and autonomy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en91",
      "id": "en91r"
    }
  }, [_vm._v("91")])]), _vm._v(" These may have avoided the most oppressive of colonial relations, but they remained forms of imperial oversight nonetheless and should not be excluded from discussions of decolonization, as historian Anthony Hopkins has persuasively argued."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en92",
      "id": "en92r"
    }
  }, [_vm._v("92")])]), _vm._v(" The creation of the Commonwealth was in large part meant to sustain beneficial relations of economic assistance and favorable terms of trade in the midst of postwar decolonization."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en93",
      "id": "en93r"
    }
  }, [_vm._v("93")])]), _vm._v(" But it also provided perhaps a bit of psychological relief for the dislocation generated by empire’s demise. Evoking his childhood in Essex and along the Thames, historian Simon Schama recalled how he would watch “the ships move purposefully out to sea toward all those places colored pink on our wall map at school, where bales of kapok or sisal or cocoa beans waited on some tropical dock so that the Commonwealth (as we had been told to call it) might pretend to live up to its name.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en94",
      "id": "en94r"
    }
  }, [_vm._v("94")])]), _vm._v(" Certainly there was much more pink to satisfy the eye on a map of the Commonwealth than there would be on a map of the colonies, as the Colonial Office seems to have concluded. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0112"
    }
  }, [_vm._v("Figure 1.12")]), _vm._v(" shows a map from the 1964 Colonial Office List. Rather than the lonely colonies meagerly scattered on its map of two years earlier (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0102"
    }
  }, [_vm._v("fig. 1.2")]), _vm._v("), here the image of the global place and reach of England is reasserted by emphasizing the Commonwealth member states. The map, not surprisingly, bears a striking resemblance to those produced around 1910, at the apex of Britain’s imperial reach. A comforting image, perhaps, especially for those who still found in empire much about which to crow."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en95",
      "id": "en95r"
    }
  }, [_vm._v("95")])]), _vm._v(" The chairman of council of the United Empire Society in 1958 had the following to say when explaining the society’s name change, from the United Empire Society to the Royal Commonwealth Society: “This is an exciting and challenging moment in our history. Our proposed name change is "), _c('i', [_vm._v("not a retreat from Empire")]), _vm._v(". It is a proud assertion of what British Imperialism has created, namely a great commonwealth of free nations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en96",
      "id": "en96r"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0112"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "420",
      "src": "images/chi-akerman-fig01012.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.12.")]), _vm._v(" A comfort map. Directorate of Overseas Surveys, "), _c('i', [_vm._v("Map of the World")]), _vm._v(". Insert in "), _c('i', [_vm._v("The Colonial Office List, 1964")]), _vm._v(". (London: Her Majesty’s Stationery Office, 1964).")])]), _vm._v(" "), _c('p', [_vm._v("But of course, not all former colonies were reborn as free nations. Canada’s trajectory from colony to full independence spanned decades, culminating finally in 1982, followed shortly thereafter by the publication, in 1987, of the remarkable "), _c('i', [_vm._v("Historical Atlas of Canada")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en97",
      "id": "en97r"
    }
  }, [_vm._v("97")])]), _vm._v(" The point is myriad forms of political life thrive both between and outside the poles of nation-state and colony. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p39"
    }
  }), _vm._v("Stewart Firth’s accounting of the status of many island communities in Oceania is revealing:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Guam is officially an “organized unincorporated territory” seeking to become a “commonwealth” of the United States; American Samoa is a “US unorganized unincorporated territory”; the Northern Mariana Islands are a US commonwealth that, by many people’s reckoning, is still part of the US Trust Territory of the Pacific Islands; Tonga is an independent kingdom; Tokelau is New Zealand territory; the Cook Islands are a self-governing state in free association with New Zealand; Wallis and Futuna are an overseas territory of France; Kiribati is an independent republic; and so on."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en98",
      "id": "en98r"
    }
  }, [_vm._v("98")])])])]), _vm._v(" "), _c('p', [_vm._v("It would be tempting to see in this a kind of truncated decolonization: that is, to view such myriad political forms cynically, as yet more instantiations of colonial rule reconfigured in such a way so as not to offend enlightened sensibilities. Certainly this is indeed partially the case. The United Nations Special Committee on Decolonization as recently as 2009 still considered Guam to be a colony."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en99",
      "id": "en99r"
    }
  }, [_vm._v("99")])]), _vm._v(" Its history had been wedded to that of other former Spanish possessions which came under the control of the United States in the aftermath of the Spanish-Cuban-American War of 1898 and occupied revealingly peripheral locations on one map in Rand McNally’s postwar "), _c('i', [_vm._v("Imperial Atlas")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0113"
    }
  }, [_vm._v("fig. 1.13")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0113"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "674",
      "src": "images/chi-akerman-fig01013.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.13.")]), _vm._v(" Manifest colonization. Rand McNally’s historical map of US expansion. Rand McNally, "), _c('i', [_vm._v("New Imperial Atlas of the World")]), _vm._v(" (Chicago: Rand McNally, 1905).")])]), _vm._v(" "), _c('p', [_vm._v("What to do with such possessions, and their populations, proved a thorny issue for the self-described “empire of liberty.” In the case of Puerto Rico, the Supreme Court, in a moment of inspired verbal gymnastics, determined that the populace of newly acquired Puerto Rico was “foreign [ . . . ] in a domestic sense.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en100",
      "id": "en100r"
    }
  }, [_vm._v("100")])]), _vm._v(" To this day the status of many former colonial possessions in the Pacific remains complicated. Many have been and continue to be defined by the strategic military objectives of their former masters: Japan, France, the United States, and, to a lesser degree, England. Cold War concerns of the United States ensured that archipelagoes such as Micronesia would not garner full independence but rather a kind of loose autonomy—a Compact of Free Association—overseen by the strategic needs of the United States, even if the US secretary of war insisted that the islands “are not colonies; they are outposts” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0114"
    }
  }, [_vm._v("fig. 1.14")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en101",
      "id": "en101r"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', [_vm._v("But such a position should not be held without some measure of recognition for the voices of the formerly colonized themselves, who thought carefully and critically about the positives and negatives of full political independence. Burbank and Cooper have observed that “as recently as the 1950s influential "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p40"
    }
  }), _vm._v("leaders in French West Africa argued that confederation in which France and its former colonies would be equal participants was preferable to the breakup of empire into independent nation-states.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en102",
      "id": "en102r"
    }
  }, [_vm._v("102")])]), _vm._v(" Debates over the status of Puerto Rico frequently revolve around whether the island would in fact become more dependent on the United States if it were to garner political independence. Similar debates characterize parts of Oceania that were formerly under "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p41"
    }
  }), _vm._v("French rule, where any discussion of independence has to consider the impact it would have on subsidies from the metropole."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en103",
      "id": "en103r"
    }
  }, [_vm._v("103")])]), _vm._v(" In these cases, those who have the most at stake in the debate recognize that colonialism is a relation of dependence built on more than political foundations. The economic power of multinational corporations, international monetary institutions, and industrial metropoles can mean economic dependence persists despite political independence"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p42"
    }
  }), _vm._v(" and should force us to question the value of terms such as “decolonization” or “postcolonial.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en104",
      "id": "en104r"
    }
  }, [_vm._v("104")])]), _vm._v(" In other words, and despite the knotty analytical and definitional questions it provokes, it is worth considering colonialism as something more than a "), _c('i', [_vm._v("political")]), _vm._v(" relation of asymmetry.")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0114"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "469",
      "src": "images/chi-akerman-fig01014.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.14.")]), _vm._v(" Outposts, not colonies. US claims over “formerly Jap islands” in 1947. A short article next to the map noted the following: “The United States presented to the United Nations a plan calling for UN trusteeship over 623 former Japanese-mandated islands, with the U.S. as administrator. [ . . . ] The United States made it clear that regardless of the United Nations’ decision, it will retain control over the islands to ensure American security.” Detail from News Map of the Week, Inc., “World News of the Week,” Vol. 9, No. 26 (Monday, February 24, 1947). Courtesy of Olin Library Map Collection.")])]), _vm._v(" "), _c('p', [_vm._v("Indeed, at the very height of decolonization, in the 1950s and 1960s, intellectuals in parts of Africa and Latin America began to write of "), _c('i', [_vm._v("neo")]), _vm._v("colonialism, questioning the determinations of what constituted the end of colonial rule through the lens of international political economy. Was it purely an issue of political self-determination and formal structures of political power? Had colonial rule collapsed with the flight of the colonial powers? To what degree had national autonomy severed the unequal relationship of dependency between metropole and periphery, or north and south, or colonizer and colonized? How could, for example, the promise of self-determination be fulfilled if confronted with the strategic threat of capital flight?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en105",
      "id": "en105r"
    }
  }, [_vm._v("105")])]), _vm._v(" Critics of capitalism "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p43"
    }
  }), _vm._v("have long stressed its deeply implicated relationship with colonialism. Thus, even as colonial empires crumbled, a variety of voices argued that the demise of colonialism might be called into question by the persistence of capitalism. Within Latin America intellectuals such as Raúl Prebisch (1946), Andre Gunder Frank (1967), Eduardo Galeano (1971), and Fernando Henrique Cardoso and Enzo Faletto (1969) generated historical analyses and interpretations that offered trenchant explanations for a world still deeply colonized by tracing historical networks and spatial grids of capitalist dependency, in the process highlighting the structural relationship between “development” and “underdevelopment.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en106",
      "id": "en106r"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', [_vm._v("That such perspectives came out of Latin America is no surprise. There, despite a century of formal political independence, countries had struggled to free themselves of the yoke of European and, increasingly, US economic and political power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en107",
      "id": "en107r"
    }
  }, [_vm._v("107")])]), _vm._v(" So much so, in fact, that Frantz Fanon invoked Latin "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p44"
    }
  }), _vm._v("America’s historical experience in his writings on Algerian decolonization: “The national bourgeoisie of certain underdeveloped countries has learned nothing from books. If they had looked closer at the Latin American countries they doubtless would have recognized the dangers which threaten them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en108",
      "id": "en108r"
    }
  }, [_vm._v("108")])]), _vm._v(" To be clear, there was no “scramble for Latin America” comparable to the “scramble for Africa,” in which European powers annexed and carved up the continent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en109",
      "id": "en109r"
    }
  }, [_vm._v("109")])]), _vm._v(" Even so, politically freed from colonial rule, Latin American statesmen and elites had to contend (or ally themselves) with new imperial formations, namely, British and subsequently US commercial hegemony and its attendant political machinations and occasional interventions. Despite the US-issued Monroe Doctrine of 1823, it was initially the British who were most powerful in “postcolonial” Spanish America. They owned the large homes in many of Spanish America’s primary cities; maintained men-of-war off the coasts of various nation-states to protect their commerce; negotiated the best treaties of friendship, commerce, and navigation with newly emergent nation-states in return for political recognition; and mapped the lands and resources to which they would informally lay claim. Indeed, the musings of a British foreign secretary in 1824 were both prescient and a cogent summation of the state of things: “Spanish America is free, and if we do not mismanage our affairs sadly, she is English.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en110",
      "id": "en110r"
    }
  }, [_vm._v("110")])]), _vm._v(" And to some degree “she” was, at least until the latter half of the nineteenth century when US hegemony grew substantially in the hemisphere.")]), _vm._v(" "), _c('p', [_vm._v("US hemispheric hegemony brought with it a more recognizably colonial set of relations at times, most dramatically with the Spanish-Cuban-American War of 1898, the subsequent occupation of Cuba and the Spanish Pacific, and the annexation of Puerto Rico. US readers followed the paths of empire in an array of cartographic and ethnographic publications—with revealing titles such as the "), _c('i', [_vm._v("American Colonial Handbook")]), _vm._v(" and "), _c('i', [_vm._v("Our Islands and Their People")]), _vm._v("—assembled to help the populace assimilate these new possessions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en111",
      "id": "en111r"
    }
  }, [_vm._v("111")])]), _vm._v(" Roosevelt’s 1904 Corollary to the Monroe Doctrine, which legitimized US intervention in Latin American countries to protect business interests or collect debts, drew on the language of paternalism and barbarism in affirming the neocolonial relationship. So too did Roosevelt’s secretary of state, Elihu Root. The two hemispheres complemented each other, he noted: the people in the south needed North American manufactures, and North Americans needed the south’s raw materials. “Where we accumulate,” remarked Root, “they spend. While we have less of the cheerful philosophy which finds happiness in the existing conditions of life, they have less of the inventive faculty which strives continually "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p45"
    }
  }), _vm._v("to increase the productive power of men.” Cartographic cartoons translated the point for a broader public (fig 1.15).")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0115"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "597",
      "src": "images/chi-akerman-fig01015.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.15.")]), _vm._v(" Debt crisis. Charles L. “Bart” Bartholomew’s cartoon appeared in the "), _c('i', [_vm._v("Minneapolis Journal")]), _vm._v(" ca. 1903. It portrays the purported lack of fiscal responsibility of various Latin American countries and serves as a valuable reminder that debt crises are not particularly new. Its appearance so close to Roosevelt’s corollary to the Monroe Doctrine is telling. Reproduced from John Johnson, "), _c('i', [_vm._v("Latin America in Caricature")]), _vm._v(" (University of Texas Press), 41.")])]), _vm._v(" "), _c('p', [_vm._v("US imperial aspirations affected other countries in the hemisphere in more subtle, if just as important, ways. Mexico, for example, could never shrug off its proximity to the northern colossus, and patterns of US development and investment exercised substantial influence in the country. Mexico’s revolution (1910–1920) was one that in some ways sought to surpass the limits imposed by the geopolitical and economic realities of early globalization and the age of empire."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en112",
      "id": "en112r"
    }
  }, [_vm._v("112")])]), _vm._v(" Revolutionaries sought not only political change but also the elimination"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p46"
    }
  }), _vm._v(" of the latifundia (or large landholding) that had characterized much of the countryside both prior to and after independence. But they also sought to curtail the influence of foreign capital, investment, and ownership in the country. Foreign capital’s presence was manifest in the north, where owners and managers settled, intermarried, and hobnobbed with regional elites. In the Yucatán Peninsula, such presence was more latent but felt nonetheless. Much of Mexico’s populace carried with it histories and memories of repeated foreign interventions, by the US military, Napoleon III’s troops, and gringo Rangers, among others. “Neocolonial” is too strong a term for the relationship, but the perception of foreign control and influence existed nonetheless."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en113",
      "id": "en113r"
    }
  }, [_vm._v("113")])]), _vm._v(" The revolutionary governments, in an assertion of sovereignty, assumed control over all mineral and subsoil rights and maintained the right to expropriate "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p47"
    }
  }), _vm._v("foreign companies. They also engaged in a far-reaching agrarian reform. In all of this, maps were crucial, and the revolutionary state hastened to train a new generation of land surveyors and agronomists loyal to the state and its revolutionary project. Along with rural schoolteachers, surveyors and agronomists became the pivotal figures in a new era characterized by its cultural and economic nationalism, as can be discerned from their presence in much postrevolutionary nationalist art ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0116"
    }
  }, [_vm._v("fig. 1.16")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en114",
      "id": "en114r"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0116"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-akerman-fig01016.jpeg",
      "width": "462"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.16.")]), _vm._v(" Revolutionary surveyors. Diego Rivera, sketch from "), _c('i', [_vm._v("Ilustración para la Primera Convención de la Liga de Comunidades Agrarias y Sindicatos Campesinos del Estado de Tamaulipas, 1926")]), _vm._v(". N.p., 1926.")])]), _vm._v(" "), _c('p', [_vm._v("Other revolutions followed, revolutions that might be situated within the language of anticolonialism or national liberation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en115",
      "id": "en115r"
    }
  }, [_vm._v("115")])]), _vm._v(" Guatemala’s democratic aperture and October Revolution of the 1940s, and the agrarian reform law 900 passed by Jacobo Árbenz in 1952, sought to put an end to the egregious and arbitrary power of an entire class of agrarian lords, led by the US-based United Fruit Company. While there was little in terms of foreign enterprises to expropriate, the reforms to land and mining in Bolivia in the early 1950s were justified in part by President Victor Paz Estenssoro as the beginning of the end to four hundred years of oppression."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en116",
      "id": "en116r"
    }
  }, [_vm._v("116")])]), _vm._v(" During the 1959 overthrow of Fulgencio Batista’s US-coddled regime in Cuba, revolutionaries self-consciously evoked the anticolonial insurgencies of a half century prior. Such revolutions occurred in tandem with, and drew inspiration from, anticolonial insurrections elsewhere, building on an earlier transcontinental precedent set in 1927 in Brussels with the first meeting of the League Against Imperialism (attendees included future leaders of independence movements from around the globe as well as a number of Latin American intellectuals, such as Víctor Rául Haya de la Torre, from Peru, and the Mexican José Vasoncelos, who spoke on behalf of Puerto Rico.)"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en117",
      "id": "en117r"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', [_vm._v("Such efforts after World War II ran parallel to, and often up against, newfangled attempts to create structures that would ensure a system of free trade and capitalist longevity—structures, such as the United Nations, the World Bank, and the International Monetary Fund, that effectively proved Karl Polanyi’s point that the invisible hand of the free market depends on the long arm of state intervention."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en118",
      "id": "en118r"
    }
  }, [_vm._v("118")])]), _vm._v(" They also confronted a bipolar world in which the Soviet Union and the United States sought to shape the political and economic relations of countries in order to ensure control over and access to a range of primary resources, without being encumbered by formal colonial rule."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en119",
      "id": "en119r"
    }
  }, [_vm._v("119")])]), _vm._v(" Thus, Mohammad Mossadeq’s attempted nationalization of oil in Iran and Jacobo Árbenz’s agrarian reform efforts in Guatemala both met with an increasingly common form of Cold War neocolonial response: CIA-sponsored coups d’état (1953 and 1954, respectively) and the imposition of authoritarian regimes committed to protecting foreign direct investment and the interests of foreign "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p48"
    }
  }), _vm._v("multinationals and domestic elite partners. The social and political conflict that ensued in the wake of these imperial intrusions was, in the maps pinned to the walls of US schools, cast as a product of Soviet ambition (figs. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0117a"
    }
  }, [_vm._v("1.17a")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0117b"
    }
  }, [_vm._v("1.17b")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0117a"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "670",
      "src": "images/chi-akerman-fig01017a.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.17a.")]), _vm._v(" Guerrillas in our midst. In this Central America wall map published by the Civic Education Service in 1966 for classroom use, the author writes, under the heading “Sleepy Republics Begin to Stir,” that “Communists, organized from nearby Cuba, are active in several of the countries. They are a particularly big threat in Guatemala. Two different guerrilla bands are spreading terror in that land. One, led by a half-Chinese, owes its allegiance to Peking.” "), _c('i', [_vm._v("Central America, Headline-focus wall map 13")]), _vm._v(", vol. 3, number 13, 1966. Copyright Scholastic. Reproduced with permission. Courtesy of Olin Library Map Collection, Cornell University.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0117b"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "854",
      "src": "images/chi-akerman-fig01017b.jpg",
      "width": "900"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.17b.")]), _vm._v("(detail). Leaders of each Central American country are highlighted, followed by a comment on “Red Guerrilla Activity” in the country.")])]), _vm._v(" "), _c('p', [_vm._v("Cartography was not immune to or removed from such questions. New structures, combined with the quickening collapse of old imperial formations, saw the emergence of new spatial conceptualizations and mental cartographies. Former geographic frameworks premised upon colonial empires and continental divisions gave way to ones shaped by Cold War geopolitics. Area studies paradigms, which compartmentalized the world according to world regions of strategic importance with a certain amount of supposed cultural coherence, and the three-worlds paradigm, first used in 1952 and which organized "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p49"
    }
  }), _vm._v("the globe according to political ideologies and presumed stages of development, both achieved institutional and political validity and shaped subsequent mappings of the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en120",
      "id": "en120r"
    }
  }, [_vm._v("120")])]), _vm._v(" These paradigms did not go unchallengedl, as intellectuals from both the global north and the global south offered alternative, and implicitly decolonial, images of their own. As well as the world systems maps already mentioned, one could include here Joaquín Torres-García’s 1936 inverted sketch of the map of South America, which derived from his broader project to forge a universal artistic aesthetic that neither rejected nor privileged European models ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0118"
    }
  }, [_vm._v("fig. 1.18")]), _vm._v("); or Arno Peters’s alternative global projections, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p50"
    }
  }), _vm._v("which critiqued traditional cartographic projections on the grounds of Eurocentrism; or Buckminster Fuller’s nonoriented (and nonaligned) Dymaxion map of 1946: all reveal that dominant cartographic and geographic frameworks were never hegemonic and that maps were used repeatedly as a means to challenge particular ways of “thinking” the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en121",
      "id": "en121r"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0118"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-akerman-fig01018.jpeg",
      "width": "430"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.18.")]), _vm._v(" An area study. Joaquín Torres-García’s south-at-the-top map of 1936.")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p51"
    }
  }), _vm._v("Decolonization (and the cold war) was lived daily, not only in the colonies but also “at home.” French philosopher Henri Lefebvre, after World War II, spent much of his life writing about and analyzing what he called “the colonization of everyday life.” Decolonization of the periphery was, for Lefebvre, unfolding simultaneously with a kind of recolonization of the metropole, especially in the realm of everyday life, with the expansion of the market, new patterns of consumption, the rise of cybernetics and information systems, and bureaucratized systems of planning associated with what he termed the state mode of production. The state form and monopoly capitalism had invaded every space—public or private, work or leisure—and effectively colonized everyday life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en122",
      "id": "en122r"
    }
  }, [_vm._v("122")])]), _vm._v(" Lefebvre, inspired by anarchist forbears, hinted at how a more authentic form of decolonization might be found in the ideas and practices of "), _c('i', [_vm._v("autogestion")]), _vm._v(" (self-management or workers’ control)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en123",
      "id": "en123r"
    }
  }, [_vm._v("123")])]), _vm._v(" The Situationists in the 1950s and 1960s, inspired and mentored by Lefebvre even as they fell out with him over time, sought to find ways to contest and subvert what they saw as the alienating forces of capitalism and bureaucracy, in part through their spatial practices. This included efforts to subvert conventional cartographic forms of representation, such as the well-known map by Guy Debord entitled "), _c('i', [_vm._v("The Naked City")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0119"
    }
  }, [_vm._v("fig. 1.19")]), _vm._v("). Drawing on the Situationists’ emphasis on psychogeography and "), _c('i', [_vm._v("détournement")]), _vm._v(" (on wandering, reroutings, digressions), the map seeks to unsettle standard, purportedly transparent forms of representation and instead juxtapose images and words removed from their original context, in a kind of “hijacking” of original material."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en124",
      "id": "en124r"
    }
  }, [_vm._v("124")])]), _vm._v(" The map critiques not only the claims to realism of standard cartographic representation at the time but also attempts to disassemble the bird’s-eye perspective, the overview, so standard in most maps. Here the view is an overview but one “piecing together an experience of space that is actually terrestrial, fragmented, subjective, temporal and cultural.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en125",
      "id": "en125r"
    }
  }, [_vm._v("125")])]), _vm._v(" The Situationist map—in some sense a countermap—exposes and subverts the close tie between Cartesian perspective and capitalism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en126",
      "id": "en126r"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0119"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "411",
      "src": "images/chi-akerman-fig01019.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page"
  }), _c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.19.")]), _vm._v(" Disassemblage. Guy Debord’s cartographic effort to capture the experience of Parisian urban space and to challenge the grid overlays of postwar planners.")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0105"
    }
  }, [_vm._v("VI. A COLONIAL PRESENT?")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("So where does this all leave us? My point here is not to suggest an absolute continuity between colonial and postcolonial states but rather to reiterate a basic point: the unequal relationships that have structured the globe exist on a continuum. An overemphasis on decolonization or postcolonialism can obscure how such forms of domination have been adjusted rather than abolished."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en127",
      "id": "en127r"
    }
  }, [_vm._v("127")])]), _vm._v(" It is hardly coincidental that the high point of decolonization coincided"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p52"
    }
  }), _vm._v(" politically with a “cold war” and economically with the rapid expansion of multinational—and increasingly transnational—corporations and, by the 1970s, post-Fordist production methods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en128",
      "id": "en128r"
    }
  }, [_vm._v("128")])]), _vm._v(" And for the peoples of much of Oceania the cold irony, as the website of the University of Hawai‘i’s Center for Pacific Islands Studies notes, is that “political power was restored to colonized peoples [of Oceania] just when the significance of the sovereign nation-state was declining in the face of unprecedented levels of global interdependence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en129",
      "id": "en129r"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', [_vm._v("Such trends continue into our colonial present. The purported end of the Cold War gave rise to suggestions that, as political scientist Francis Fukuyama put it, the end of history itself was at hand: that liberalism had emerged as the motor of historical progress, assigning alternatives—communism and socialism, among others—to the dustbin of history."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en130",
      "id": "en130r"
    }
  }, [_vm._v("130")])]), _vm._v(" Fukuyama’s geopolitical vision is staunchly cartographic and uncannily colonial: former colonial powers by and large are where history has come to its end; meanwhile, the rest of the world remains woefully “historical.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en131",
      "id": "en131r"
    }
  }, [_vm._v("131")])]), _vm._v(" The conflation of geography and temporality so crucial to the colonial enterprise reappears yet again.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p53"
    }
  }), _vm._v("Still, could it be the case that generally the last of colonialism’s remnants have been dismantled? Historian Charles Maier has suggested that the collapse of the Soviet Union meant the end of the last of the classic land-based empires. Others have argued that residents in postsocialist Eastern and Southern Europe have engaged in a process of “institutional, disciplinary and psychological decolonization . . . from state socialism,” one that involves various remappings, particularly of property."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en132",
      "id": "en132r"
    }
  }, [_vm._v("132")])]), _vm._v(" Perhaps . . . although others have drawn on the language of colonialism to make sense of rapid changes taking place in the former Soviet Union and its ex-satellites. Anthropologist Katherine Verdery shows in detail, for the case of Aurel Vlaicu, Transylvania (modern-day Romania), the unpredictable and messy process of transition from a state-run to a free-market economy—and the concomitant emphasis on creating or restoring private property under the auspices of the IMF and the World Bank—and how it has enabled “new forms of western colonization through transferring expertise, employing Eastern Europe’s cheap skilled labor force, and flooding markets hitherto closed to western products.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en133",
      "id": "en133r"
    }
  }, [_vm._v("133")])]), _vm._v(" Across the breadth of former Soviet states, local and regional elites have used privatization schemes to gather and consolidate expanses of land, even as the state immerses itself further in, rather than withdraws from, economic life. Similar processes have been underway since the 1980s in parts of Latin America, most notably in Mexico, where, with the implementation of the North American Free Trade Agreement in 1994, the government declared land redistribution officially at an end. Lands distributed to petitioners after the revolution could now be sold, rented, and circulated on the market."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en134",
      "id": "en134r"
    }
  }, [_vm._v("134")])]), _vm._v(" Despite the claims that such changes constitute the withdrawal of the state from the economy, the fact is such initiatives have spurred the creation of new bureaucracies tasked with the mapping and titling of such properties.")]), _vm._v(" "), _c('p', [_vm._v("Such moves are part of a longer trend. The Keynesian paradigm that developed in the wake of the Depression and World War II—alongside processes of decolonization—has yielded now to an aggressive free-market absolutism, referred to in short-hand as “neoliberalism.” State industries are being dismantled, food subsidies abolished, tariffs and protectionist measures removed, currencies devalued, and the public sector abandoned. Institutions created under the Bretton Woods agreement have transformed themselves into international creditors with substantial power over the political and economic destinies of states around the globe, regardless of their purported “independence.” (The first time I looked at Bart’s cartoon ["), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0115"
    }
  }, [_vm._v("fig. 1.15")]), _vm._v("], I thought not of Roosevelt’s Corollary or the Monroe Doctrine, but of the IMF and the long history of debt crises brought on by strategic lending and interest rate manipulations.) If "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p54"
    }
  }), _vm._v("colonialism seems to cast a long shadow, it may be because it still stands there in the full light of day. Tax-free zones created in parts of Africa have been justified, according to the BBC, by economists with a particularly colonial cartographic logic: they “argue that free trade zones are particularly suited to African countries which were created under colonial occupation when land was divided up, often with little regard for the economic sustainability of the newly created plot.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en135",
      "id": "en135r"
    }
  }, [_vm._v("135")])]), _vm._v(" Little wonder that the gross national product of many African countries is no larger than the annual sales of some multinationals ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0120"
    }
  }, [_vm._v("fig. 1.20")]), _vm._v("). Multinationals—in finance, technology, and an array of diversified holdings—and some individuals have acquired a political heft and financial girth comparable to that of the high imperial states of yore. Have we returned to the era of the company-state? Perhaps we never left it. Now we just call them multinationals. Regardless, endeavors long considered the purview of states only due to the exorbitant expense—such as space exploration—have now been taken up by individuals whose personal wealth often exceeds the GDP of many smaller nations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en136",
      "id": "en136r"
    }
  }, [_vm._v("136")])]), _vm._v(" What map will capture that?")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0120"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p55"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "900",
      "src": "images/chi-akerman-fig01020.jpg",
      "width": "724"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGURE 1.20.")]), _vm._v(" The company-state. One of a series of maps produced by the Brazilian magazine "), _c('i', [_vm._v("Superinteresante")]), _vm._v(". This one maps equivalences between multinational companies’ annual sales and the gross national product of a country. For example, “sales for Nike are equivalent to the gross national product of Niger.” “Empresas que valem a Africa,” reproduced in Frank Jacobs, "), _c('i', [_vm._v("Strange Maps: An Atlas of Cartographic Curiosities")]), _vm._v(" (New York: Penguin, 2009), 190, quoted text from 190.")])]), _vm._v(" "), _c('p', [_vm._v("To be sure, claims regarding the nation-state’s demise have been greatly exaggerated—after all, it is taxpayer money and US state intervention that opened up Iraq to an array of multinational corporations, with the US First Cavalry Division leading the charge in “Operation Adam Smith.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en137",
      "id": "en137r"
    }
  }, [_vm._v("137")])]), _vm._v(" Operation Adam Smith helped implement L. Paul Bremer’s and the Coalition Provisional Authority’s “100 orders,” which transformed Iraqi law, including dramatic changes in copyright and patent law and the setting of a legal framework to facilitate the transfer of public commons to private hands."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en138",
      "id": "en138r"
    }
  }, [_vm._v("138")])]), _vm._v(" Geographic information system (GIS) technologies and renewed attention to the power of “geography” in foreign policy circles have accompanied these shifts, creating new controversies over mapping, countermapping, and forms of purported geopiracy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en139",
      "id": "en139r"
    }
  }, [_vm._v("139")])]), _vm._v(" Just how central a role new cartographic technologies play in all of this is indicated by a particularly blunt appraisal of one US military official: “GIS is how civilians spell IPB [Intelligence Preparation of the Battlefield].”")]), _vm._v(" "), _c('p', [_vm._v("At the same time, such technologies, like their predecessors, can be used to resist, deflect, or otherwise undermine dominant paradigms. That is, they have counterhegemonic potential. Cartographers have produced radical atlases and have crafted maps that draw public attention to everything from new processes of militarization to patterns of migration, flows of capital, and movements of production."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en140",
      "id": "en140r"
    }
  }, [_vm._v("140")])]), _vm._v(" Others have developed mapping practices that attempt to avoid the hierarchies of knowledge production and intervene meaningfully and politically. For example, the countercartographies collective based at the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p56"
    }
  }), _vm._v("University of North Carolina in Chapel Hill has sought to generate maps that capture “the changing landscape of labor when production is geographically diffused.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en141",
      "id": "en141r"
    }
  }, [_vm._v("141")])]), _vm._v(" Open source tools and other mechanisms have, to some degree, democratized cartography or at least, in the words of Jeremy Crampton and John Krygier, “undisciplined it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en142",
      "id": "en142r"
    }
  }, [_vm._v("142")])]), _vm._v(" Whether or not this constitutes a form of “decolonizing the map”—akin to the efforts of indigenous communities who countermap, or the Situationists and their anti-Cartesian spaces—is an open question but certainly one worth asking, inasmuch as it raises again the perenniel issue of the originary relationship between modern cartography and colonial expansion.")]), _vm._v(" "), _c('p', [_vm._v("I may, by this point, have stretched the term “colonial” (and therefore “decolonial”) beyond any useful measure. Perhaps that is a worthwhile endeavor in that it suggests to us that the very terms “colonial” and “decolonial” may simply not be sufficient—analytically, historically, politically—for making sense of the long processes under discussion here; that such terms are more usefully understood as aspects of a larger problematic—capitalism, perhaps, or modernity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en143",
      "id": "en143r"
    }
  }, [_vm._v("143")])]), _vm._v(" But even if one were not to go that far, even if we were to recognize (as we should) that there were serious and meaningful repercussions to legal independence, that it "), _c('i', [_vm._v("meant")]), _vm._v(" something, the cases just discussed at the minimum serve as a reminder of the persistence of colonialism as something more than a system of overextended political rule. A final series of maps may help emphasize the point: these are maps that show the “proportion of worldwide Gross Domestic Product measured in US$ equalised for purchasing power parity,” for years 1500, 1900, and 1960 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#fig0121"
    }
  }, [_vm._v("figs. 1.21–23")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en144",
      "id": "en144r"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "fig0121"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p57"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "280",
      "src": "images/chi-akerman-fig01021.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "280",
      "src": "images/chi-akerman-fig01022.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "280",
      "src": "images/chi-akerman-fig01023.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("FIGUREs 1.21–23.")]), _vm._v(" Parity and the longue durée. Proportion of worldwide gross domestic product, in US dollars, equalized for purchasing power parity, for the years 1500, 1900, and 1960. Copyright worldmapper. "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.worldmapper.org/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.worldmapper.org/")]), _vm._v(". Reproduced with permission.")])]), _vm._v(" "), _c('p', [_vm._v("Confronted with such images, one can understand the skepticism expressed by the "), _c('i', [_vm._v("Midnight Notes Collective")]), _vm._v(" in 1990: “‘Colonial emancipation’ is a phrase that, if anyone has the bad taste to bring it up, can only cause derision.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiAkerman0009#en145",
      "id": "en145r"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0106"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("My thanks to my fellow participants in the Nebenzahl Lecture Series, where this was first delivered: Tom Bassett, Magali Carrera, Lina del Castillo, Karen Culcasi, Jordana Dym, Jamie McGowan, and Sumathi Ramaswamy. I am indebted to Jim Akerman, David Bernstein, Ryan Edwards, Durba Ghosh, Dan Magaziner, Jon Parmenter, Jim Scott, Suman Seth, and Robert Travers for reading and commenting on this essay at various stages. I owe a special debt of gratitude to Ben Brower, David Hanlon, Dane Kennedy, Alan Knight, and Ted Melillo, for very detailed critiques of the penultimate draft. My thanks also to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p58"
    }
  }), _vm._v("the two anonymous referees for the Press, who pushed me in generous and productive ways. I have not taken all of their advice, but I hope they see the results of their efforts here. Portions of this essay appeared in an abbreviated version prepared for volume 6 of "), _c('i', [_vm._v("The History of Cartography")]), _vm._v(" (Chicago: University of Chicago Press, 2015) at the kind invitation of Mark Monmonier.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0107"
    }
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en1r",
      "id": "en1"
    }
  }, [_vm._v("1.")]), _vm._v(" J. F. Horrabin, "), _c('i', [_vm._v("An Atlas of Empire")]), _vm._v(" (New York: Knopf, 1937), 13.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en2r",
      "id": "en2"
    }
  }, [_vm._v("2.")]), _vm._v(" Ibid., 3. For a succinct biography of Horrabin, his work, and the description of him as a working-class educator, see Leslie W. Hepple, “Socialist Geography in England: J. F. Horrabin and a Workers’ Economic and Political Geography,” "), _c('i', [_vm._v("Antipode")]), _vm._v(" 31 (January 1999): 80–109.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en3r",
      "id": "en3"
    }
  }, [_vm._v("3.")]), _vm._v(" Frantz Fanon, "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(" (New York: Grove Press, 1968), 102; for a broad expansion on Fanon’s assertion, see Edward Said, "), _c('i', [_vm._v("Culture and Imperialism")]), _vm._v(" (New York: Vintage, 1993).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en4r",
      "id": "en4"
    }
  }, [_vm._v("4.")]), _vm._v(" Aimé Césaire, "), _c('i', [_vm._v("Discourse on Colonialism")]), _vm._v(" (New York: Monthly Review Press, [1955] 2000). See also the discussion in Robert Young, "), _c('i', [_vm._v("White Mythologies: Writing History and the West")]), _vm._v(" (London: Routledge, 1991), 39. I am grateful to Ben Brower for pointing out the specificity of Césaire’s phrase “boomerang effect.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en5r",
      "id": "en5"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('i', [_vm._v("Rand McNally & Co.’s New Standard Atlas of the World")]), _vm._v(" (Chicago: Rand, McNally & Co., 1898). Capitals in the original.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en6r",
      "id": "en6"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('i', [_vm._v("The Colonial Office List, 1962")]), _vm._v(" (London: Her Majesty’s Stationery Office, 1962), map insert.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en7r",
      "id": "en7"
    }
  }, [_vm._v("7.")]), _vm._v(" “Africa 1965,” news map by Edwin Sundberg (News Syndicate Co., 1965); E. J. Hobsbawm, "), _c('i', [_vm._v("The Age of Extremes: A History of the World, 1914–1991")]), _vm._v(" (New York: Vintage, 1996), 344.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en8r",
      "id": "en8"
    }
  }, [_vm._v("8.")]), _vm._v(" Mark Monmonier, “The Rise of the National Atlas,” "), _c('i', [_vm._v("Cartographica")]), _vm._v(" 31, no. 1 (1994): 1–15.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en9r",
      "id": "en9"
    }
  }, [_vm._v("9.")]), _vm._v(" National Geographic Magazine, “Africa: Atlas Plate 54, September 1960.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en10r",
      "id": "en10"
    }
  }, [_vm._v("10.")]), _vm._v(" Prasenjit Duara, “The Decolonization of Asia and Africa in the Twentieth Century,” in "), _c('i', [_vm._v("Decolonization: Perspectives from Now and Then")]), _vm._v(", ed. Prasenjit Duara (London: Routledge, 2003), 1; and more broadly Patrick Wolfe, “History and Imperialism: A Century of Theory, from Marx to Postcolonialism,” "), _c('i', [_vm._v("American Historical Review")]), _vm._v(" 102, no. 2 (April 1997): 388–420. Hence the value of proceeding as much by “comparison” as by “analysis,” a point made cogently by Paul Feyerabend in his "), _c('i', [_vm._v("Against Method: An Outline of an Anarchistic Theory of Knowledge")]), _vm._v(" (London: Verso, [1972] 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en11r",
      "id": "en11"
    }
  }, [_vm._v("11.")]), _vm._v(" I am indebted to Dane Kennedy, Alan Knight, and one of the press’s anonymous readers for pushing me on the distinctions.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en12r",
      "id": "en12"
    }
  }, [_vm._v("12.")]), _vm._v(" Fernando Coronil, “After Empire: Reflections on Imperialism from the Americas,” in "), _c('i', [_vm._v("Imperial Formations")]), _vm._v(", ed. Ann Laura Stoler, Carole McGranahan, and Peter Perdue (Santa Fe, NM: SAR Press, 2007); Greg Grandin, "), _c('i', [_vm._v("The Last Colonial Massacre: Latin America and the Cold War")]), _vm._v(" (Chicago: University of Chicago Press, 2004); and Walter LaFeber, "), _c('i', [_vm._v("Inevitable Revolutions: The United States in Central America")]), _vm._v(", 2nd ed. (New York: W. W. Norton, 1993).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en13r",
      "id": "en13"
    }
  }, [_vm._v("13.")]), _vm._v(" See Duara, “The Decolonization of Asia and Africa in the Twentieth Century,” 8; Aijaz Ahmad, "), _c('i', [_vm._v("In Theory: Classes, Nations, Literatures")]), _vm._v(" (London: Verso, 1992), passim; and Vijay Prashad, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p59"
    }
  }), _c('i', [_vm._v("The Darker Nations: A People’s History of the Third World")]), _vm._v(" (New York: New Press, 2007). On anarchism and anticolonialism, see especially Benedict Anderson, "), _c('i', [_vm._v("Under Three Flags: Anarchism and the Anticolonial Imagination")]), _vm._v(" (London: Verso, 2005); as well as Michael Schmidt and Lucien van der Walt, "), _c('i', [_vm._v("Black Flame: The Revolutionary Class Politics of Anarchism and Syndicalism")]), _vm._v(" (Oakland: AK Press, 2009); and Lucien van der Walt and Steven Hirsch, eds., "), _c('i', [_vm._v("Anarchism and Syndicalism in the Colonial and Postcolonial World, 1870–1940: The Praxis of National Liberation, Internationalism, and Social Revolution")]), _vm._v(" (Leiden: Brill, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en14r",
      "id": "en14"
    }
  }, [_vm._v("14.")]), _vm._v(" Jane Burbank and Fred Cooper, "), _c('i', [_vm._v("Empires in World History: Power and the Politics of Difference")]), _vm._v(" (Princeton: Princeton University Press, 2010), 10–11.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en15r",
      "id": "en15"
    }
  }, [_vm._v("15.")]), _vm._v(" Jeremy Adelman, "), _c('i', [_vm._v("Sovereignty and Revolution in the Iberian Atlantic")]), _vm._v(" (Princeton: Princeton University Press, 2006), 396.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en16r",
      "id": "en16"
    }
  }, [_vm._v("16.")]), _vm._v(" Hobsbawm, "), _c('i', [_vm._v("Age of Extremes")]), _vm._v(", 208; Charles Maier, “Consigning the Twentieth Century to History: Alternative Narratives for the Modern Era,” "), _c('i', [_vm._v("American Historical Review")]), _vm._v(" 105, no. 3 (June 2000): 807–31.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en17r",
      "id": "en17"
    }
  }, [_vm._v("17.")]), _vm._v(" For varied perspectives on colonial and postcolonial boundary making see D. G. Burnett, "), _c('i', [_vm._v("Masters of All They Surveyed: Exploration, Geography and a British El Dorado")]), _vm._v(" (Chicago: University of Chicago Press, 2001); Thongchai Winichakul, "), _c('i', [_vm._v("Siam Mapped: A History of the Geo-body of a Nation")]), _vm._v(" (Honolulu: University of Hawaii Press, 1994); Lucy Chester, "), _c('i', [_vm._v("Borders and Conflict in South Asia: The Radcliffe Boundary Commission and the Partition of Punjab")]), _vm._v(" (Manchester: Manchester University Press, 2009); Paula Rebert, "), _c('i', [_vm._v("La Gran Linea: Mapping the United States–Mexico Boundary, 1849–1857")]), _vm._v(" (Austin: University of Texas Press, 2001); Eric Worby, “Maps, Names and Ethnic Games: The Epistemology and Iconography of Colonial Power in Northwestern Zimbabwe,” "), _c('i', [_vm._v("Journal of Southern African Studies")]), _vm._v(" 20, no. 3 (1994): 371–92; and Donald S. Moore, "), _c('i', [_vm._v("Suffering for Territory: Race, Place and Power in Zimbabwe")]), _vm._v(" (Durham: Duke University Press, 2005). For a superb study attentive to the social history of borders, see Bernardo Michael, "), _c('i', [_vm._v("Statemaking and Territory in South Asia: Lessons from the Anglo-Gorkha War (1814–1816)")]), _vm._v(" (London: Anthem Press, 2012).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en18r",
      "id": "en18"
    }
  }, [_vm._v("18.")]), _vm._v(" Matthew Sparke, "), _c('i', [_vm._v("In the Space of Theory: Postfoundational Geographies of the Nation-State")]), _vm._v(" (Minneapolis: University of Minnesota Press, 2005), 12.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en19r",
      "id": "en19"
    }
  }, [_vm._v("19.")]), _vm._v(" Raymond Betts, "), _c('i', [_vm._v("Decolonization")]), _vm._v(", 2nd ed. (New York: Routledge 2004), 2, 55; Jeffrey Stone, "), _c('i', [_vm._v("A Short History of Cartography in Africa")]), _vm._v(" (Lewiston, ME.: E. Mellen Press, 1995), 77.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en20r",
      "id": "en20"
    }
  }, [_vm._v("20.")]), _vm._v(" Jorge Domínguez et al., "), _c('i', [_vm._v("Boundary Disputes in Latin America")]), _vm._v(" (Washington, DC: United States Institute of Peace, 2003).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en21r",
      "id": "en21"
    }
  }, [_vm._v("21.")]), _vm._v(" See Tamar Herzog, “Historical Right to Land: Politics, History and Law in Latin America” (paper presented at conference “Rethinking Space in Latin America,” Yale University, 2014). For close study of one example of postcolonial boundary conflicts see the analysis of the boundary between Ecuador and Peru in Eric J. Lyman, “War of the Maps,” in "), _c('i', [_vm._v("Mercator’s World")]), _vm._v(", at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ericjlyman.com/mercators2.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.ericjlyman.com/mercators2.html")]), _vm._v(" (last accessed August 23, 2010); and, with particular emphasis on the relationship between science and nationalism in nineteenth-century Ecuador, Ana María Sevilla Pérez, “El Ecuador en sus mapas: Estado y nación desde una perspectiva espacial” (doctoral thesis, FLACSO [Ecuador], 2011). On the Argentine-Chilean boundary and Patagonia, see Richard O. Perry, “Argentina and Chile: The Struggle for Patagonia, 1843–1881,” "), _c('i', [_vm._v("Americas")]), _vm._v(" 36, no. 3 (1980): 347–63; and, for an astute social history, Alberto Harambour-Ross, “Borderland Sovereignties: Postcolonial Colonialism and State Making in Patagonia (Argentina and Chile, 1840s–1922)” (Ph.D. dissertation, Stony Brook University, 2012). For how the Argentine state used a prison as a means to set the bounds of state power in Patagonia, see Ryan "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p60"
    }
  }), _vm._v("Edwards, “From the Depths of Patagonia: The Ushuaia Penal Colony and the Nature of ‘the End of the World,’” "), _c('i', [_vm._v("Hispanic American Historical Review")]), _vm._v(" 94, no. 2 (May 2014): 271–302.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en22r",
      "id": "en22"
    }
  }, [_vm._v("22.")]), _vm._v(" Albert Memmi, "), _c('i', [_vm._v("The Colonizer and the Colonized")]), _vm._v(", expanded edition (Boston: Beacon Press, [1957] 1965), 39; see also Benedict Anderson, "), _c('i', [_vm._v("Imagined Communities: Reflections on the Origin and Spread of Nationalism")]), _vm._v(", rev. ed. (London: Verso Press, 1991); Frantz Fanon, "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(", esp. “On National Culture”; Edward Said, "), _c('i', [_vm._v("Culture and Imperialism")]), _vm._v(", esp. chap. 3; and Seamus Deane, “Introduction,” in "), _c('i', [_vm._v("Nationalism, Colonialism and Literature")]), _vm._v(", by Terry Eagleton, Frederic Jameson, and Edward W. Said (Minneapolis: University of Minnesota Press, 1990); and Terry Eagleton, “Nationalism: Irony and Commitment,” in ibid.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en23r",
      "id": "en23"
    }
  }, [_vm._v("23.")]), _vm._v(" Hobsbawm, "), _c('i', [_vm._v("Age of Extremes")]), _vm._v(", 202; John D. Kelly and Martha Kaplan, “‘My Ambition Is Much Higher Than Independence’: US Power, the UN World, the Nation-State, and Their Critics,” in Duara, "), _c('i', [_vm._v("Decolonization")]), _vm._v(", 131–51; David Chappell, “A ‘Headless’ Native Talks Back: Nidoish Naisseline and the Kanak Awakening in 1970s New Caledonia,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 22, no. 1 (Spring 2010): 37–70; and more generally Dipesh Chakrabarty, "), _c('i', [_vm._v("Provincializing Europe: Postcolonial Thought and Historical Difference")]), _vm._v(" (Princeton: Princeton University Press, 2000); and Ranajit Guha and Gayatri Chakravorty Spivak, eds., "), _c('i', [_vm._v("Selected Subaltern Studies")]), _vm._v(" (London: Oxford University Press, 1998).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en24r",
      "id": "en24"
    }
  }, [_vm._v("24.")]), _vm._v(" Ngugi wa Thiong’o, "), _c('i', [_vm._v("Decolonising the Mind: The Politics of Language in African Literature")]), _vm._v(" (London: James Currey, 1986). See also Ashis Nandy"), _c('i', [_vm._v(", The Intimate Enemy: Loss and Recovery of Self under Colonialism")]), _vm._v(", 2nd ed. (London: Oxford University Press, [1983] 2010). On decolonizing knowledge, for Latin America see Aníbal Quijano, “Coloniality of Power, Eurocentrism and Latin America,” "), _c('i', [_vm._v("Nepantla: Views from the South")]), _vm._v(" 1, no. 3 (2000): 533–80; more broadly, Graham Huggan, “Decolonizing the Map: Post-colonialism, Post-structuralism and the Cartographic Connection,” in "), _c('i', [_vm._v("Interdisciplinary Measures: Literature and the Future of Postcolonial Studies")]), _vm._v(" (Liverpool: Liverpool University Press, 2008), chap. 1; the essays collected as part of the special issue entitled “Back to the Future: Decolonizing Pacific Studies,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 15, no. 1 (Spring 2003): 1–148; and Linda Smith, "), _c('i', [_vm._v("Decolonizing Methodologies: Research and Indigenous Peoples")]), _vm._v(", 2nd ed. (London: Zed Books, 2013). For an excellent essay on the importance of new flags and anthems, among other things, to cultural decolonization in self-governed dominions of the British Empire, see Anthony Hopkins, “Rethinking Decolonization,” "), _c('i', [_vm._v("Past and Present")]), _vm._v(" 200 (August 2008): 211–47.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en25r",
      "id": "en25"
    }
  }, [_vm._v("25.")]), _vm._v(" A subject much commented upon but nowhere explored with more nuance than in Paul Carter, "), _c('i', [_vm._v("The Road to Botany Bay: An Exploration of Landscape and History")]), _vm._v(" (Chicago: University of Chicago Press, 1987).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en26r",
      "id": "en26"
    }
  }, [_vm._v("26.")]), _vm._v(" See, as a sampling, the perspectives offered in Renee Pualani Louis, “Indigenous Hawaiian Cartographer: In Search of Common Ground,” "), _c('i', [_vm._v("Cartographic Perspectives")]), _vm._v(" 48 (Spring 2004): 7–23; and the related discussion in Jay T. Johnson, Renee Pualani Louis, and Albertus Pradi Halmono, “Facing the Future: Encouraging Critical Cartographic Literacies in Indigenous Communities,” "), _c('i', [_vm._v("ACME: An International E-Journal for Critical Geographies")]), _vm._v(" 4, no. 1 (2005): 80–98; Keith Basso, "), _c('i', [_vm._v("Wisdom Sits in Places: Landscape and Language among the Western Apache")]), _vm._v(" (Albuquerque: University of New Mexico Press, 1995); and Epeli Hau‘ofa, “Pasts to Remember,” in "), _c('i', [_vm._v("We Are the Ocean: Selected Works")]), _vm._v(" (Honolulu: University of Hawaii Press, 2008), 60–79. See also the discussion of alternative modes of writing and recording history in David Hanlon, “Beyond ‘the English Method of Tattooing’: Decentering the Practice of History in Oceania,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 15, no. 1 (Spring 2003): 19–40.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p61"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en27r",
      "id": "en27"
    }
  }, [_vm._v("27.")]), _vm._v(" Brian Friel, "), _c('i', [_vm._v("Translations")]), _vm._v(" (London: Faber & Faber, 1981), 25. I am aware of the critiques leveled at Friel’s play, especially by J. H. Andrews, whose own work overturns any mistaken impressions left in the reader regarding the mapping of Ireland. See J. H. Andrews, "), _c('i', [_vm._v("A Paper Landscape: The Ordnance Survey of Nineteenth-Century Ireland")]), _vm._v(" (Oxford: Oxford University Press, 1975); and Andrews, “Notes for a Future Edition of Brian Friel’s "), _c('i', [_vm._v("Translations")]), _vm._v(",” "), _c('i', [_vm._v("Irish Review")]), _vm._v(" 13 (Winter 1992/93): 93–106. Having said that, a fair defense of Friel’s work can be made by noting that too literal a reading of the play makes for a poor translation.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en28r",
      "id": "en28"
    }
  }, [_vm._v("28.")]), _vm._v(" Epeli Hau‘ofa, “Our Sea of Islands,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 6, no. 1 (1994): 148–61, quoted passage on 152–53.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en29r",
      "id": "en29"
    }
  }, [_vm._v("29.")]), _vm._v(" Ibid., 150. For discussions of Hau‘ofa’s work see Margaret Jolly, “Imagining Oceania: Indigenous and Foreign Representations of a Sea of Islands,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 19, no. 2 (2007): 508–45; Arif Dirlik, “There Is More in the Rim Than Meets the Eye: Thoughts on the “Pacific Idea,”” in "), _c('i', [_vm._v("The Postcolonial Aura: Third World Criticism in the Age of Global Capitalism")]), _vm._v(" (Boulder. CO: Westview Press, 1997), 129–45; Paul D’Arcy, "), _c('i', [_vm._v("The People of the Sea: Environment, Identity and History in Oceania")]), _vm._v(" (Honolulu: University of Hawai‘i Press, 2006), esp. the conclusion; David Hanlon, “The Sea of Little Lands: Examining Micronesia’s Place in ‘Our Sea of Islands,’” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 21, no. 1 (2009): 91–110; and the special section dedicated to his work in "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 22, no. 1 (Spring 2010): 101–23. More broadly, see Philip E. Steinberg, "), _c('i', [_vm._v("The Social Construction of the Ocean")]), _vm._v(" (Cambridge: Cambridge University Press, 2001); and Matt Matsuda, "), _c('i', [_vm._v("Pacific Worlds: A History of Seas, Peoples, and Cultures")]), _vm._v(" (Cambridge: Cambridge University Press, 2012).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en30r",
      "id": "en30"
    }
  }, [_vm._v("30.")]), _vm._v(" Bruce G. Karolle, "), _c('i', [_vm._v("Atlas of Micronesia")]), _vm._v(" (Mangilao, Guam: Guam Publications, 1987), 30. Here he is discussing the perceptions of Satawalese and Pulutawese navigators, from Micronesia.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en31r",
      "id": "en31"
    }
  }, [_vm._v("31.")]), _vm._v(" “The canoe,” one student of the subject has written, “is conceived as stationary beneath the equally fixed position of the stars and sun. The sea flows past, and the islands move astern.” Ibid., 30–31. The classic study is David H. Lewis, "), _c('i', [_vm._v("We, the Navigators: The Ancient Art of Landfinding in the Pacific")]), _vm._v(" (Honolulu: University of Hawai‘i Press, [1972] 1974). See also the film "), _c('i', [_vm._v("Sacred Vessels: Navigating Tradition and Identity in Micronesia")]), _vm._v(", directed by Vicente Diaz (Pacific Islanders in Communication, 1997).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en32r",
      "id": "en32"
    }
  }, [_vm._v("32.")]), _vm._v(" Cited from David Turnbull, “Cook and Tupaia, a Tale of Cartographic Méconnaissance?,” in "), _c('i', [_vm._v("Science and Exploration in the Pacific: European Voyages to the Southern Oceans in the Eighteenth Century")]), _vm._v(", ed. Margarette Lincoln (Woodbridge, Suffolk, UK: Boydell Press, 1998), 120.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en33r",
      "id": "en33"
    }
  }, [_vm._v("33.")]), _vm._v(" Jolly, “Imagining Oceania,” 509; emphasis in the original. For slightly different emphases regarding the map and the question of authorship, see Gordon R. Lewthwaite, “The Puzzle of Tupaia’s Map,” "), _c('i', [_vm._v("New Zealand Geographer")]), _vm._v(" 26 (April 1970): 1–19; and Turnbull, “Cook and Tupaia.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en34r",
      "id": "en34"
    }
  }, [_vm._v("34.")]), _vm._v(" Thongchai, "), _c('i', [_vm._v("Siam Mapped")]), _vm._v("; Raymond B. Craib, “A Nationalist Metaphysics: State Fixations, National Maps and the Geo-historical Imagination in Nineteenth-Century Mexico,” "), _c('i', [_vm._v("Hispanic American Historical Review")]), _vm._v(" 82, no. 1 (February 2002): 33–68; Bulent Batuman, “The Shape of the Nation: Visual Production of Nationalism through Maps in Turkey,” "), _c('i', [_vm._v("Political Geography")]), _vm._v(" 29, no. 4 (May 2010): 220–34; and Firoozeh Kashani-Sabet, "), _c('i', [_vm._v("Frontier Frictions: Shaping the Iranian Nation, 1804–1946")]), _vm._v(" (Princeton: Princeton University Press, 1999).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en35r",
      "id": "en35"
    }
  }, [_vm._v("35.")]), _vm._v(" Sumathi Ramaswamy, “Maps and Mother Goddesses in Modern India,” "), _c('i', [_vm._v("Imago Mundi")]), _vm._v(" 53 (2001): 97–114, cited passage on 100. See also Sumathi Ramaswamy, "), _c('i', [_vm._v("The Goddess and the Nation: Mapping Mother India")]), _vm._v(" (Durham: Duke University Press, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en36r",
      "id": "en36"
    }
  }, [_vm._v("36.")]), _vm._v(" Monmonier, “Rise of the National Atlas” (n. 8 above), 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p62"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en37r",
      "id": "en37"
    }
  }, [_vm._v("37.")]), _vm._v(" Jeremy Black, "), _c('i', [_vm._v("Maps and History: Constructing Images of the Past")]), _vm._v(" (New Haven: Yale University Press, 1997), 186.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en38r",
      "id": "en38"
    }
  }, [_vm._v("38.")]), _vm._v(" For a trenchant discussion see Fouad Makki, “Imperial Fantasies, Colonial Realities: Contesting Power and Culture in Italian Eritrea,” "), _c('i', [_vm._v("South Atlantic Quarterly")]), _vm._v(" 107 (Fall 2008): 735–54; as well as Ranajit Guha, "), _c('i', [_vm._v("History at the Limit of World-History")]), _vm._v(" (New York: Columbia University Press, 2003). For complementary perspectives, see Johannes Fabian, "), _c('i', [_vm._v("Time and the Other: How Anthropology Makes Its Object")]), _vm._v(" (New York: Columbia University Press, 1983); Eric R. Wolf, "), _c('i', [_vm._v("Europe and the People without History")]), _vm._v(" (Berkeley: University of California Press, 1982); Fanon, “On National Culture,” in "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(" (n. 3 above); William Roseberry and Jay O’Brien, eds., "), _c('i', [_vm._v("Golden Ages, Dark Ages: Imagining the Past in Anthropology and History")]), _vm._v(" (Berkeley: University of California Press, 1991); and James C. Scott, "), _c('i', [_vm._v("The Art of Not Being Governed: An Anarchist History of Upland Southeast Asia")]), _vm._v(" (New Haven: Yale University Press, 2010). For a discussion that repeatedly hints at the simultaneous processes of homogenization and fragmentation that structured the universe of possibilities within which decolonizing states could be born, see the essays of Henri Lefebvre collected in "), _c('i', [_vm._v("State, Space, World: Selected Essays")]), _vm._v(", ed. Neil Brenner and Stuart Elden (Minneapolis: University of Minnesota Press, 2009).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en39r",
      "id": "en39"
    }
  }, [_vm._v("39.")]), _vm._v(" Nicholas Thomas, "), _c('i', [_vm._v("In Oceania: Visions, Artifacts, Histories")]), _vm._v(" (Durham: Duke University Press, 1997), 9; Margaret Jolly, “Specters of Inauthenticity,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 4, no. 1 (1992): 49–72.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en40r",
      "id": "en40"
    }
  }, [_vm._v("40.")]), _vm._v(" Adelman, "), _c('i', [_vm._v("Sovereignty and Revolution")]), _vm._v(" (n. 15 above), 346. More broadly on this question I have found especially useful the critiques of postcolonial theory and third world literatures by Ahmad, "), _c('i', [_vm._v("In Theory")]), _vm._v(" (n. 13 above); and Neil Larsen, "), _c('i', [_vm._v("Determinations")]), _vm._v(" (London: Verso, 2001); and Larsen, "), _c('i', [_vm._v("Reading North by South")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1995).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en41r",
      "id": "en41"
    }
  }, [_vm._v("41.")]), _vm._v(" Fred Cooper, "), _c('i', [_vm._v("Colonialism in Question")]), _vm._v(" (Princeton: Princeton University Press, 2003), 27; Jolly, “Specters of Inauthenticity,” 54.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en42r",
      "id": "en42"
    }
  }, [_vm._v("42.")]), _vm._v(" J. Jorge Klor de Alva, “The Postcolonization of the (Latin) American Experience: A Reconsideration of ‘Colonialism,’ ‘Postcolonialism,’ and ‘Mestizaje,’” in "), _c('i', [_vm._v("After Colonialism: Imperial Histories and Postcolonial Displacements")]), _vm._v(", ed. Gyan Prakash (Princeton: Princeton University Press, 1994).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en43r",
      "id": "en43"
    }
  }, [_vm._v("43.")]), _vm._v(" Burbank and Cooper, "), _c('i', [_vm._v("Empires in World History")]), _vm._v(" (n. 14 above), 293.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en44r",
      "id": "en44"
    }
  }, [_vm._v("44.")]), _vm._v(" Ibid. For a compelling treatment of the paradox of liberty and slavery, see Greg Grandin, "), _c('i', [_vm._v("The Empire of Necessity: Slavery, Freedom and Deception in the New World")]), _vm._v(" (New York: Metropolitan Books, 2014).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en45r",
      "id": "en45"
    }
  }, [_vm._v("45.")]), _vm._v(" Fanon, "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(", 176.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en46r",
      "id": "en46"
    }
  }, [_vm._v("46.")]), _vm._v(" Ibid., 152.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en47r",
      "id": "en47"
    }
  }, [_vm._v("47.")]), _vm._v(" Rebecca Earle, "), _c('i', [_vm._v("The Return of the Native")]), _vm._v(": "), _c('i', [_vm._v("Indians and Myth-Making in Spanish America, 1810–1930")]), _vm._v(" (Durham: Duke University Press, 2007); and Luis Villoro, "), _c('i', [_vm._v("Los grandes momentos del indigenismo en México")]), _vm._v(" (Mexico City: Secretaría de Educación Pública, 1987). On archeology see Cristina Bueno, “Forjando patrimonio: The Making of Archaeological Patrimony in Porfirian Mexico,” "), _c('i', [_vm._v("Hispanic American Historical Review")]), _vm._v(" 90, no. 2 (May 2010): 215–46; and Stefanie Ganger, “Conquering the Past: Post-war Archaeology and Nationalism in the Borderlands of Chile and Peru, c. 1880–1920,” "), _c('i', [_vm._v("Comparative Studies in Society and History")]), _vm._v(" 51, no. 4 (2009): 691–714. On the work of Antonio García Cubas, see Raymond Craib, "), _c('i', [_vm._v("Cartographic Mexico: A History of State Fixations and Fugitive Landscapes")]), _vm._v(" (Durham: Duke University Press, 2004), chap. 1; Magali Carrera, "), _c('i', [_vm._v("Traveling")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p63"
    }
  }), _c('i', [_vm._v("from New Spain to Mexico: Mapping Practices of Nineteenth Century Mexico")]), _vm._v(" (Durham: Duke University Press, 2011); and Hugo Pichardo Hernández, “Hacia la conformación de una geografía nacional: Antonio García Cubas y el territorio mexicano, 1853–1912” (unpublished MA thesis, Universidad Nacional Autónoma de México, 2004).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en48r",
      "id": "en48"
    }
  }, [_vm._v("48.")]), _vm._v(" Black, "), _c('i', [_vm._v("Maps and History")]), _vm._v(", 166–67. See also Tom Bassett’s essay in this volume.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en49r",
      "id": "en49"
    }
  }, [_vm._v("49.")]), _vm._v(" Mahmood Mamdani, "), _c('i', [_vm._v("Saviors and Survivors: Darfur, Politics and the War on Terror")]), _vm._v(" (New York: Pantheon, 2009), 177. As I was in the process of revising this essay, South Sudan became an independent nation-state (July 9, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en50r",
      "id": "en50"
    }
  }, [_vm._v("50.")]), _vm._v(" For a thoughtful intervention here, see Charles Maier, “Leviathan 2.0,” in "), _c('i', [_vm._v("A World Connecting, 1870–1945")]), _vm._v(", ed. Emily S. Rosenberg (Cambridge, MA: Belknap Press of Harvard University Press, 2012), 189–91.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en51r",
      "id": "en51"
    }
  }, [_vm._v("51.")]), _vm._v(" Robert J. C. Young, "), _c('i', [_vm._v("Postcolonialism: An Historical Introduction")]), _vm._v(" (Oxford: Wiley-Blackwell, 2001), 223 (citing Winston James, "), _c('i', [_vm._v("Holding Aloft the Banner of Ethiopia")]), _vm._v(": "), _c('i', [_vm._v("Caribbean Radicalism in Early Twentieth Century America")]), _vm._v(" [London: Verso, 1999], 246).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en52r",
      "id": "en52"
    }
  }, [_vm._v("52.")]), _vm._v(" See Rudolfo Acuña, "), _c('i', [_vm._v("Occupied America")]), _vm._v(": "), _c('i', [_vm._v("The Chicanos Struggle toward Liberation")]), _vm._v(" (San Francisco: Canfield, 1972); and Mario Barrera, "), _c('i', [_vm._v("Race and Class in the Southwest: A Theory of Racial Inequality")]), _vm._v(" (Notre Dame: University of Notre Dame Press, 1979); and, more recently, Armando Navarro, "), _c('i', [_vm._v("Mexicano Political Experience in Occupied Aztlán: Struggles and Change")]), _vm._v(" (Walnut Creek, CA: AltaMira Press, 2005). With some forty years’ distance, Acuña’s claim might appear a bit dated; a quick peek at Samuel Huntington’s "), _c('i', [_vm._v("The Clash of Civilizations and the Remaking of World Order")]), _vm._v(" (New York: Simon & Schuster, 1998) will quickly dispel any such thought.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en53r",
      "id": "en53"
    }
  }, [_vm._v("53.")]), _vm._v(" Jean-Paul Sartre, “The Third World Begins in the Suburbs,” in "), _c('i', [_vm._v("We Have Only This Life to Live: Selected Essays, 1939–1975")]), _vm._v(", ed. Ronald Aronson and Adrian van den Howen (New York: NYRB, 2013), 487; Paulo Freire, "), _c('i', [_vm._v("The Politics of Education: Culture, Power and Liberation")]), _vm._v(" (Westport, CT: Greenwood Press, 1985), 139–40.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en54r",
      "id": "en54"
    }
  }, [_vm._v("54.")]), _vm._v(" Michael Hardt and Antonio Negri, "), _c('i', [_vm._v("Empire")]), _vm._v(" (Cambridge, MA: Harvard University Press, 2000), 132–34.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en55r",
      "id": "en55"
    }
  }, [_vm._v("55.")]), _vm._v(" Cooper, "), _c('i', [_vm._v("Colonialism in Question")]), _vm._v(", 18. See also Akhil Gupta, “The Song of the Nonaligned World: Transnational Identities and the Reinscription of Space in Late Capitalism,” in "), _c('i', [_vm._v("Culture, Power, Place")]), _vm._v(": "), _c('i', [_vm._v("Explorations in Critical Anthropology")]), _vm._v(", ed. Akhil Gupta and James Ferguson (Durham: Duke University Press, 1997), 179–99; and the introduction and essays in Christopher J. Lee, ed., "), _c('i', [_vm._v("Making a World after Empire: The Bandung Moment and Its Political Afterlives")]), _vm._v(" (Athens: Ohio University Press, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en56r",
      "id": "en56"
    }
  }, [_vm._v("56.")]), _vm._v(" See Florencia Mallon’s discussion of Ada Ferrer’s work on Cuba in “Pathways to Postcolonial Nationhood: The Democratization of Difference in Contemporary Latin America,” in "), _c('i', [_vm._v("Postcolonial Studies and Beyond")]), _vm._v(", ed. Ania Loomba et al. (Durham: Duke University Press, 2005), 273–92; Ada Ferrer, "), _c('i', [_vm._v("Insurgent Cuba: Race, Nation and Revolution, 1868–1898")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1999).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en57r",
      "id": "en57"
    }
  }, [_vm._v("57.")]), _vm._v(" Anderson, "), _c('i', [_vm._v("Under Three Flags")]), _vm._v(" (n. 13 above), 54 and passim; Ilham Khuri-Makdisi, "), _c('i', [_vm._v("The Eastern Mediterranean and the Making of Global Radicalism, 1860–1914")]), _vm._v(" (Berkeley: University of California Press, 2010); Steven Hirsch and Lucien van der Walt, “Rethinking Anarchism and Syndicalism: The Colonial and Postcolonial Experience, 1870–1940,” in van der Walt and Hirsch, "), _c('i', [_vm._v("Anarchism and Syndicalism")]), _vm._v(" (n. 13 above), xxxi–lxxiii; Maia Ramnath, "), _c('i', [_vm._v("Decolonizing Anarchism: An Anti-authoritarian History of India’s Liberation Struggle")]), _vm._v(" (Oakland: AK Press, 2011); Sho Kinishi, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p64"
    }
  }), _c('i', [_vm._v("Anarchist Modernity: Cooperatism and Japanese-Russian Intellectual Relations in Modern Japan")]), _vm._v(" (Cambridge, MA: Harvard University Press, 2013); and Barry Maxwell and Raymond Craib, eds., "), _c('i', [_vm._v("No Gods No Masters No Peripheries: Global Anarchisms")]), _vm._v(" (Oakland, CA: PM Press, 2015).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en58r",
      "id": "en58"
    }
  }, [_vm._v("58.")]), _vm._v(" Rosalind Morris, “Remembering Asian Anticolonialism, Again,” "), _c('i', [_vm._v("Journal of Asian Studies")]), _vm._v(" 69, no. 2 (May 2010): 347–69, quote on 351.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en59r",
      "id": "en59"
    }
  }, [_vm._v("59.")]), _vm._v(" Scott, "), _c('i', [_vm._v("The Art of Not Being Governed")]), _vm._v(", 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en60r",
      "id": "en60"
    }
  }, [_vm._v("60.")]), _vm._v(" Partha Chatterjee, "), _c('i', [_vm._v("Nationalist Thought and the Colonial World: A Derivative Discourse")]), _vm._v(" (Minneapolis: University of Minnesota Press, [1986] 1993).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en61r",
      "id": "en61"
    }
  }, [_vm._v("61.")]), _vm._v(" A point made by Matthew Edney, “The Irony of Imperial Mapping,” in "), _c('i', [_vm._v("The Imperial Map: Cartography and the Mastery of Empire")]), _vm._v(", ed. James Akerman (Chicago: University of Chicago Press, 2009).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en62r",
      "id": "en62"
    }
  }, [_vm._v("62.")]), _vm._v(" Black, "), _c('i', [_vm._v("Maps and History")]), _vm._v(" (n. 37 above), 186.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en63r",
      "id": "en63"
    }
  }, [_vm._v("63.")]), _vm._v(" Acknowledging this is essential if we are to avoid inadvertently suggesting that the colonized are largely derivative (and the colonizer, conversely, largely autonomous). Chatterjee’s "), _c('i', [_vm._v("Nationalist Thought and the Colonial World")]), _vm._v(" raises precisely such issues but does seem to suggest that there is no escaping some essential, autonomous West. For a cogent discussion, see Sumathi Ramaswamy’s review of the book in "), _c('i', [_vm._v("Journal of Asian Studies")]), _vm._v(" 53, no. 3 (August 1994): 960–61. Similar critiques were leveled at Edward Said’s "), _c('i', [_vm._v("Orientalism")]), _vm._v(". More broadly, on seeing colonialism and the modern world as produced dialectically and through processes of transculturation, I have found especially useful Said, "), _c('i', [_vm._v("Culture and Imperialism")]), _vm._v(" (n. 22 above); Jean Comaroff and John Comaroff, "), _c('i', [_vm._v("Of Revelation and Revolution")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("Christianity, Colonialism and Consciousness in South Africa")]), _vm._v(" (Chicago: University of Chicago Press, 1991); John Comaroff and Jean Comaroff, "), _c('i', [_vm._v("Of Revelation and Revolution")]), _vm._v(", vol. 2, "), _c('i', [_vm._v("The Dialectics of Modernity on a South African Frontier")]), _vm._v(" (Chicago: University of Chicago Press, 1997); and Mary Louise Pratt, "), _c('i', [_vm._v("Imperial Eyes: Travel Writing and Transculturation")]), _vm._v(" (London: Routledge, 1992).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en64r",
      "id": "en64"
    }
  }, [_vm._v("64.")]), _vm._v(" For a critique of the argument that modern cartography—and science more generally—was a Western and rational construct imposed on “other” cultures, see Kapil Raj, "), _c('i', [_vm._v("Relocating Modern Science: Circulation and the Construction of Knowledge in South Asia and Europe, 1650–1900")]), _vm._v(" (New York: Palgrave MacMillan, 2007), esp. chaps. 2 and 6; but it should be read in conjunction with Matthew Edney, "), _c('i', [_vm._v("Mapping an Empire: The Geographical Construction of British India, 1765–1843")]), _vm._v(" (Chicago: University of Chicago Press, 1999), which offers a devastating critique of the very notion of rationality in the mapping of British India. I attempt to situate Raj’s work explicitly in relation to the history of cartography in Craib, “Relocating Cartography,” "), _c('i', [_vm._v("Postcolonial Studies")]), _vm._v(" 12, no. 4 (December 2009): 481–90. An excellent overview is provided by Suman Seth, “Putting Knowledge in Its Place: Science, Colonialism, and the Postcolonial,” "), _c('i', [_vm._v("Postcolonial Studies")]), _vm._v(" 12, no. 4 (2009): 373–88.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en65r",
      "id": "en65"
    }
  }, [_vm._v("65.")]), _vm._v(" On Mexico see Craib, "), _c('i', [_vm._v("Cartographic Mexico")]), _vm._v(", chap. 7; on Ghana, see Jamie McGowan’s essay in this volume.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en66r",
      "id": "en66"
    }
  }, [_vm._v("66.")]), _vm._v(" Stone, "), _c('i', [_vm._v("A Short History")]), _vm._v(" (n. 19 above), 101, 132–33.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en67r",
      "id": "en67"
    }
  }, [_vm._v("67.")]), _vm._v(" Hobsbawm notes that in the late 1940s nearly half the world’s population lived in a society undergoing some kind of land reform. See Hobsbawm, "), _c('i', [_vm._v("Age of Extremes")]), _vm._v(" (n. 7 above), 354–55.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en68r",
      "id": "en68"
    }
  }, [_vm._v("68.")]), _vm._v(" See, for examples, Thongchai, "), _c('i', [_vm._v("Siam Mapped")]), _vm._v(" (n. 17 above); and Sumathi Ramaswamy, “History at Land’s End: Lemuria in Tamil Spatial Fables,” "), _c('i', [_vm._v("Journal of Asian Studies")]), _vm._v(" 59, no. 3 (2000): esp. 586–89.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en69r",
      "id": "en69"
    }
  }, [_vm._v("69.")]), _vm._v(" Ramaswamy, "), _c('i', [_vm._v("The Goddess and the Nation")]), _vm._v(" (n. 35 above), 9. For a very similar perspective,"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p65"
    }
  }), _vm._v(" see Nancy Peluso’s discussion of countermapping in Peluso, “Whose Woods Are These? Counter-mapping Forest Territories in Kalimantan, Indonesia,” "), _c('i', [_vm._v("Antipode")]), _vm._v(" 27, no. 4 (1995): 383–406. For varied efforts to look at such processes historically, see Barbara Mundy, "), _c('i', [_vm._v("The Mapping of New Spain")]), _vm._v(": "), _c('i', [_vm._v("Indigenous Cartography and the Maps of the Relaciones Geográficas")]), _vm._v(" (Chicago: University of Chicago Press, 1997); and Craib, "), _c('i', [_vm._v("Cartographic Mexico")]), _vm._v(", chaps. 2 and 3.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en70r",
      "id": "en70"
    }
  }, [_vm._v("70.")]), _vm._v(" On agency and subjectivity, see Michel-Rolph Trouillot, "), _c('i', [_vm._v("Silencing the Past")]), _vm._v(": "), _c('i', [_vm._v("Power and the Production of History")]), _vm._v(" (Boston: Beacon Press, 1995), esp. chap. 1; on agency and passivity, see David A. Chappell, “Active Agents versus Passive Victims: Decolonized Historiography or Problematic Paradigm?,” in "), _c('i', [_vm._v("Voyaging through the Contemporary Pacific")]), _vm._v(", ed. David Hanlon and Geoffrey M. White (Lanham, MD: Rowman & Littlefield, 2000), 205–28.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en71r",
      "id": "en71"
    }
  }, [_vm._v("71.")]), _vm._v(" Raj, "), _c('i', [_vm._v("Relocating Modern Science")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en72r",
      "id": "en72"
    }
  }, [_vm._v("72.")]), _vm._v(" Joel Wainwright and Joe Bryan, “Cartography, Territory, Property: Postcolonial Reflections on Indigenous Counter-mapping in Nicaragua and Belize,” "), _c('i', [_vm._v("Cultural Geographies")]), _vm._v(" 16, no. 2 (April 2009), 153.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en73r",
      "id": "en73"
    }
  }, [_vm._v("73.")]), _vm._v(" The literature is substantial, but good starting points that wrestle with the complexities of countermapping include Peluso, “Whose Woods Are These?”; Don Monet and Skanu’u, "), _c('i', [_vm._v("Colonialism on Trial")]), _vm._v(": "), _c('i', [_vm._v("Indigenous Land Rights and the Gitksan and Wet’suwet’en Sovereignty Case")]), _vm._v(" (Philadelphia: New Society Publishers, 1991); Johnson, Louis, and Halmono, “Facing the Future”; Bjorn Sletto, “We Drew What We Imagined: Participatory Mapping, Performance, and the Arts of Landscape Making,” "), _c('i', [_vm._v("Current Anthropology")]), _vm._v(" 50 (2009): 443–76; Wainwright and Bryan, “Cartography, Territory, Property”; and Dorothy L. Hodgson and Richard A. Schroeder, “Dilemmas of Counter-mapping Community Resources in Tanzania,” "), _c('i', [_vm._v("Development and Change")]), _vm._v(" 33, no. 1 (2002): 79–100.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en74r",
      "id": "en74"
    }
  }, [_vm._v("74.")]), _vm._v(" Peter Gray, “Do the Walls Have Ears? Indigenous Title and Courts in Australia,” "), _c('i', [_vm._v("Australian Indigenous Law Reporter")]), _vm._v(" 5, no. 1 (2000), "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.austlii.edu.au/au/journals/AILR/2000/1.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.austlii.edu.au/au/journals/AILR/2000/1.html")]), _vm._v(" (last accessed October 11, 2010). See also Jane Jacobs, "), _c('i', [_vm._v("Edge of Empire")]), _vm._v(": "), _c('i', [_vm._v("Postcolonialism and the City")]), _vm._v(" (London: Routledge, 1996), esp. 113–15, who importantly notes that nonindigenous perspectives on aboriginality shaped the contours of the possible for various aboriginal groups at the time. I have also found valuable Paul Carter, "), _c('i', [_vm._v("The Road to Botany Bay")]), _vm._v(" (n. 25 above), esp. “A Wandering State”; and David Turnbull, "), _c('i', [_vm._v("Maps Are Territories: Science Is an Atlas")]), _vm._v(" (Chicago: University of Chicago Press, 1994).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en75r",
      "id": "en75"
    }
  }, [_vm._v("75.")]), _vm._v(" Sparke, "), _c('i', [_vm._v("In the Space of Theory")]), _vm._v(" (n. 18 above), chap. 1; Monet and Skanu’u, "), _c('i', [_vm._v("Colonialism on Trial")]), _vm._v(". For an excellent overview of mapping and history attentive to use perspectives, see Hugh Brody, "), _c('i', [_vm._v("Maps and Dreams: Indians and the British Colombia Frontier")]), _vm._v(" (Prospect Heights, IL: Waveland Press, [1981] 1998); as well as Paul Nadasdy, “Imposing Territoriality: First Nation Land Claims and the Transformation of Human-Environment Relations in the Yukon” (paper presented at the Cornell University Institute for the Social Sciences, September 13, 2013).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en76r",
      "id": "en76"
    }
  }, [_vm._v("76.")]), _vm._v(" Sparke, "), _c('i', [_vm._v("In the Space of Theory")]), _vm._v(", 16–29; Monet and Skanu’u, "), _c('i', [_vm._v("Colonialism on Trial.")])])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en77r",
      "id": "en77"
    }
  }, [_vm._v("77.")]), _vm._v(" Curtis Berkey, “Maps in Court,” in "), _c('i', [_vm._v("Mapping Our Places: Voices from the Indigenous Communities Mapping Initiative")]), _vm._v(" (Berkeley: Indigenous Communities Mapping Initiative, 2005), 217.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en78r",
      "id": "en78"
    }
  }, [_vm._v("78.")]), _vm._v(" Such projects can be riddled with tension. See, for example, the recent controversies surrounding the Bowman expeditions in Mexico, in particular the exchanges in the guest editorial section of "), _c('i', [_vm._v("Political Geography")]), _vm._v(" 29, no. 8 (November 2010); as well as the accusations of geopiracy presented at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://elenemigocomun.net/es/cat/mexico-indigena/",
      "target": "_blank"
    }
  }, [_vm._v("http://elenemigocomun.net/es/cat/mexico-indigena/")]), _vm._v("; and Joe Bryan and Joel Wainwright, “Letter to the Association of American Geographers” (March 18, 2009), at "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p66"
    }
  }), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://academic.evergreen.edu/g/grossmaz/HerlihyLetterSign.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://academic.evergreen.edu/g/grossmaz/HerlihyLetterSign.pdf")]), _vm._v(". For an effort to see the expeditions as part of a broader tradition in geography, see Joel Wainwright, "), _c('i', [_vm._v("Geo-piracy: Oaxaca, Militant Empiricism, and Geographical Thought")]), _vm._v(" (New York: Palgrave Pivot, 2012); and the roundtable on Wainwright’s book in "), _c('i', [_vm._v("Dialogues in Human Geography")]), _vm._v(" 4, no. 1 (March 2014).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en79r",
      "id": "en79"
    }
  }, [_vm._v("79.")]), _vm._v(" Joe Bryan, “A World Where Many Fit,” in "), _c('i', [_vm._v("Mapping Our Places")]), _vm._v(", 218.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en80r",
      "id": "en80"
    }
  }, [_vm._v("80.")]), _vm._v(" For an instructive set of exchanges, see Roger M. Keesing, “Creating the Past: Custom and Identity in the Contemporary Pacific,” in Hanlon and White, "), _c('i', [_vm._v("Voyaging through the Contemporary Pacific")]), _vm._v(", 231–54; Haunani-Kay Trask, “Natives and Anthropologists: The Colonial Struggle,” in ibid., 255–63; Keesing, “Reply to Trask,” in ibid., 264–67; Jocelyn Linnekin, “Text Bites and the R-Word: The Politics of Representing Scholarship,” in ibid., 268–73; Jolly, “Specters of Inauthenticity,” in ibid., 274–97; and Ben Finney, “The Sin at Awarua,” in ibid., 298–330.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en81r",
      "id": "en81"
    }
  }, [_vm._v("81.")]), _vm._v(" Sherry Ortner, “Resistance and the Problem of Ethnographic Refusal,” "), _c('i', [_vm._v("Comparative Studies in Society and History")]), _vm._v(" 37, no. 1 (1995): 173–93, cited passage on 176.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en82r",
      "id": "en82"
    }
  }, [_vm._v("82.")]), _vm._v(" See Michael Watts, “The Sinister Political Life of Community: Economies of Violence and Governable Spaces in the Niger Delta, Nigeria,” in "), _c('i', [_vm._v("The Romance of Community")]), _vm._v(", ed. Gerald Creed (Santa Fe, NM: SAR Press, 2007), 101–42; and Michael Watts, “Collective Wish Images: Geographical Imaginaries and the Crisis of Development,” in "), _c('i', [_vm._v("Human Geography Today")]), _vm._v(", ed. John Allen and Doreen Massey (Cambridge: Polity Press, 1999), 85–107. See also Noel Castree, “Differential Geographies: Place, Indigenous Rights and ‘Local’ Resources,” "), _c('i', [_vm._v("Political Geography")]), _vm._v(" 23 (2004): 133–67.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en83r",
      "id": "en83"
    }
  }, [_vm._v("83.")]), _vm._v(" Jon Parmenter, "), _c('i', [_vm._v("The Edge of the Woods: Iroquoia, 1534–1701")]), _vm._v(" (East Lansing: Michigan State University Press, 2010), 276. See also Carter, "), _c('i', [_vm._v("The Road to Botany Bay")]), _vm._v(", esp. the chapter entitled “A Wandering State”; Liisa H. Malkki, “National Geographic: The Rooting of Peoples and the Territorialization of National Identity among Scholars and Refugees,” in Gupta and Ferguson, "), _c('i', [_vm._v("Culture, Power, Place")]), _vm._v(" (n. 55 above), 52–74; Akhil Gupta and James Ferguson, “Beyond ‘Culture’: Space, Identity and the Politics of Difference,” in ibid., 33–51; and Doreen Massey, "), _c('i', [_vm._v("For Space")]), _vm._v(" (Thousand Oaks, CA: Sage Publications, 2005), esp. 1–8; on authenticity, structure, and change I have found especially useful the brief but excellent discussion in Trouillot, "), _c('i', [_vm._v("Silencing the Past")]), _vm._v(", chap. 5; as well as Marshall Sahlins, "), _c('i', [_vm._v("Islands of History")]), _vm._v(" (Chicago: University of Chicago Press, 1985); Greg Dening, "), _c('i', [_vm._v("Islands and Beaches: Discourse on a Silent Land: Marquesas, 1771–1880")]), _vm._v(" (Chicago: Dorsey Press, 1980); and Doreen Massey, “Places and Their Pasts,” "), _c('i', [_vm._v("History Workshop Journal")]), _vm._v(" 39 (1995): 182–92.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en84r",
      "id": "en84"
    }
  }, [_vm._v("84.")]), _vm._v(" Excellent studies that raise this point include Margaret Jolly, “On the Edge? Deserts, Oceans, Islands,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 13, no. 2 (Fall 2001): 417–66; Hau‘ofa, “Pasts to Remember” (n. 26 above), 60–79; David Chappell, "), _c('i', [_vm._v("Double Ghosts: Oceanian Voyagers on Euroamerican Ships")]), _vm._v(" (Armonk, NY: M. E. Sharpe, 1997); and Gregory Rosenthal, “Life and Labor in a Seabird Colony: Hawaiian Guano Workers, 1857–1870,” "), _c('i', [_vm._v("Environmental History")]), _vm._v(" 17 (October 2012): 744–82.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en85r",
      "id": "en85"
    }
  }, [_vm._v("85.")]), _vm._v(" See especially Richard White, “The Winning of the West: The Expansion of the Western Sioux in the Eighteenth and Nineteenth Centuries,” "), _c('i', [_vm._v("Journal of American History")]), _vm._v(" 65, no. 2 (September 1978): 319–43; and David Bernstein, “How the West Was Drawn: Indians, Maps, and the Construction of the Trans-Mississippi West” (Ph.D. dissertation, University of Wisconsin–Madison, 2011). I am indebted to David for his comments here.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en86r",
      "id": "en86"
    }
  }, [_vm._v("86.")]), _vm._v(" Pekka Hamalainen, "), _c('i', [_vm._v("The Comanche Empire")]), _vm._v(" (New Haven: Yale University Press, 2008), 1. See also the recent studies by Parmenter, "), _c('i', [_vm._v("The Edge of the Woods")]), _vm._v("; and Brian Delay, "), _c('i', [_vm._v("The War of a Thousand Deserts: Indian Raids and the U.S.-Mexican War")]), _vm._v(" (New Haven: Yale University Press, 2008).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p67"
    }
  }), _c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en87r",
      "id": "en87"
    }
  }, [_vm._v("87.")]), _vm._v(" For a powerful argument to this effect, see Scott, "), _c('i', [_vm._v("The Art of Not Being Governed")]), _vm._v(" (n. 38 above), passim but esp. chap. 6½ (yes, six and one-half!).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en88r",
      "id": "en88"
    }
  }, [_vm._v("88.")]), _vm._v(" Horrabin, "), _c('i', [_vm._v("An Atlas of Empire")]), _vm._v(", vi; my emphasis.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en89r",
      "id": "en89"
    }
  }, [_vm._v("89.")]), _vm._v(" John Gallagher and Ronald Robinson, “The Imperialism of Free Trade,” "), _c('i', [_vm._v("Economic History Review")]), _vm._v(", 2nd ser., 6, no. 1 (1953): 1–15, quoted text on 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en90r",
      "id": "en90"
    }
  }, [_vm._v("90.")]), _vm._v(" Mallon, “Pathways to Postcolonial Nationhood” (n. 56 above), esp. 278; and Aníbal Quijano, “Coloniality of Power” (n. 24 above).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en91r",
      "id": "en91"
    }
  }, [_vm._v("91.")]), _vm._v(" Burbank and Cooper, "), _c('i', [_vm._v("Empires in World History")]), _vm._v(" (n. 14 above), 16–17, 300–301.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en92r",
      "id": "en92"
    }
  }, [_vm._v("92.")]), _vm._v(" Hopkins, “Rethinking Decolonization” (n. 24 above), 211–47.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en93r",
      "id": "en93"
    }
  }, [_vm._v("93.")]), _vm._v(" Dalzeil, "), _c('i', [_vm._v("The Penguin Historical Atlas of the British Empire")]), _vm._v(" (London: Penguin, 2006), 132–33.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en94r",
      "id": "en94"
    }
  }, [_vm._v("94.")]), _vm._v(" Simon Schama, "), _c('i', [_vm._v("Landscape and Memory")]), _vm._v(" (London: HarperCollins, 1995), 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en95r",
      "id": "en95"
    }
  }, [_vm._v("95.")]), _vm._v(" Hopkins observes that recent historiography has found that “Britain’s aim in the years immediately following the Second World War was to reinvigorate the empire, not to abandon it.” The historiography to which he refers includes William Roger Lewis, "), _c('i', [_vm._v("Imperialism at Bay")]), _vm._v("; and Lewis, "), _c('i', [_vm._v("The British Empire in the Middle East")]), _vm._v(". See Hopkins, “Rethinking Decolonization,” 216.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en96r",
      "id": "en96"
    }
  }, [_vm._v("96.")]), _vm._v(" “A Message from the New Chairman of Council, the Rt. Hon. the Earl De La Warr, G.B.E.,” "), _c('i', [_vm._v("United Empire")]), _vm._v(" 49, no. 1 (January–February 1958): 1; my emphasis.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en97r",
      "id": "en97"
    }
  }, [_vm._v("97.")]), _vm._v(" Hopkins notes that it was in 1982 that Canada acquired “full control over her affairs” when the “British parliament approved a new constitution for the country.” Hopkins, “Rethinking Decolonization,” 220. On the "), _c('i', [_vm._v("Atlas")]), _vm._v(", see Sparke, "), _c('i', [_vm._v("In the Space of Theory")]), _vm._v(" (n. 18 above), chap. 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en98r",
      "id": "en98"
    }
  }, [_vm._v("98.")]), _vm._v(" Stewart Firth, “Sovereignty and Independence in the Contemporary Pacific,” "), _c('i', [_vm._v("Contemporary Pacific")]), _vm._v(" 1, no. 1–2 (1989): 75–96.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en99r",
      "id": "en99"
    }
  }, [_vm._v("99.")]), _vm._v(" Alison Mountz, “The Enforcement Archipelago: Detention, Haunting, and Asylum on Islands,” "), _c('i', [_vm._v("Political Geography")]), _vm._v(" 30 (2011): 118–28.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en100r",
      "id": "en100"
    }
  }, [_vm._v("100.")]), _vm._v(" See the collected essays in Christina Duffy Burnett and Burke Marshall, eds., "), _c('i', [_vm._v("Foreign in a Domestic Sense: Puerto Rico, American Expansion, and the Constitution")]), _vm._v(" (Durham: Duke University Press, 2001); on the "), _c('i', [_vm._v("Rand McNally Imperial Atlas")]), _vm._v(" (1905), see Raymond Craib and D. Graham Burnett, “Insular Visions: Cartographic Imagery and the Spanish-American War,” "), _c('i', [_vm._v("Historian")]), _vm._v(" 61, no. 1 (Fall 1998): 100–118.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en101r",
      "id": "en101"
    }
  }, [_vm._v("101.")]), _vm._v(" See David Hanlon, "), _c('i', [_vm._v("Remaking Micronesia: Discourses over Development in a Pacific Territory, 1944–1982")]), _vm._v(" (Honolulu: University of Hawai‘i Press, 1998). The quote by the US secretary of war is cited in Robert C. Kiste, “United States,” in "), _c('i', [_vm._v("Tides of History: The Pacific Islands in the Twentieth Century")]), _vm._v(", ed. K. R. Howe, Robert C. Kiste, and Brij V. Lal (Honolulu: University of Hawai‘i Press, 1994), 229. For a remarkable wall map that charts US territory, see William Rankin, “The Territory of the United States: A Patchwork of Jurisdictions and Rights,” available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.radicalcartography.net/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.radicalcartography.net/")]), _vm._v(" (last accessed September 20, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en102r",
      "id": "en102"
    }
  }, [_vm._v("102.")]), _vm._v(" Burbank and Cooper, "), _c('i', [_vm._v("Empires in World History")]), _vm._v(", 10–11.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en103r",
      "id": "en103"
    }
  }, [_vm._v("103.")]), _vm._v(" See, for example, the case of French Polynesia, discussed in Firth, “Sovereignty and Independence,” 76.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en104r",
      "id": "en104"
    }
  }, [_vm._v("104.")]), _vm._v(" For the case of Oceania, see Jolly, “Specters of Inauthenticity” (n. 39 above). More broadly see Dirlik, "), _c('i', [_vm._v("The Postcolonial Aura")]), _vm._v(" (n. 29 above).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en105r",
      "id": "en105"
    }
  }, [_vm._v("105.")]), _vm._v(" Fanon observed, “The spectacular flight of capital is one of the most constant phenomena of decolonization.” "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(" (n. 3 above), 103.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en106r",
      "id": "en106"
    }
  }, [_vm._v("106.")]), _vm._v(" For examples of "), _c('i', [_vm._v("dependista")]), _vm._v(" arguments with varying degrees of sophistication and passion, see inter alia Eduardo Galeano, "), _c('i', [_vm._v("The Open Veins of Latin America: Five Centuries of the Pillage")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p68"
    }
  }), _c('i', [_vm._v("of a Continent")]), _vm._v(" (New York: Monthly Review Press, [1975] 1997); Andre Gunder Frank, "), _c('i', [_vm._v("Capitalism and Underdevelopment in Latin America: Historical Skteches of Chile and Brazil")]), _vm._v(" (London: Penguin, 1971); and Fernando Henrique Cardoso and Enzo Faletto, "), _c('i', [_vm._v("Dependency and Development in Latin America")]), _vm._v(" (Berkeley: University of California Press, 1979). An offshoot of dependency was Immanuel Wallerstein’s much-debated world systems theoretic. See Wallerstein, "), _c('i', [_vm._v("The Modern World-System: Capitalist Agriculture and the Origins of the European World Economy in the Sixteenth Century")]), _vm._v(" (New York: Academic Press, 1974). For critiques see Robert Brenner, “The Origins of Capitalist Development: A Critique of Neo-Smithian Marxism,” "), _c('i', [_vm._v("New Left Review")]), _vm._v(" 104 (1977): 25–92; and Steve J. Stern, “Feudalism, Capitalism, and the World-System in the Perspective of Latin American and the Caribbean,” "), _c('i', [_vm._v("American Historical Review")]), _vm._v(" 93, no. 4 (October 1988): 829–72, which includes a response by Wallerstein. For a recent discussion in the context of postcolonial studies, see Timothy Brennan, “The Image-Function of the Periphery,” in Loomba et al., "), _c('i', [_vm._v("Postcolonial Studies and Beyond")]), _vm._v(" (n. 56 above), 101–22. For an excellent overview, see Patrick Wolfe, “History and Imperialism” (n. 10 above).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en107r",
      "id": "en107"
    }
  }, [_vm._v("107.")]), _vm._v(" For a good analysis, see Greg Grandin "), _c('i', [_vm._v("Empire’s Workshop: Latin America, the United States and the Rise of the New Imperialism")]), _vm._v(" (New York: Metropolitan Books, 2006); and Gilbert Joseph, Catherine LeGrand, and Ricardo Salvatore, eds., "), _c('i', [_vm._v("Close Encounters of Empire: Writing the Cultural History of U.S.–Latin American Relations")]), _vm._v(" (Durham: Duke University Press, 1998), esp. Joseph’s introduction.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en108r",
      "id": "en108"
    }
  }, [_vm._v("108.")]), _vm._v(" Fanon, "), _c('i', [_vm._v("The Wretched of the Earth")]), _vm._v(", 174.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en109r",
      "id": "en109"
    }
  }, [_vm._v("109.")]), _vm._v(" Alan Knight, “Britain and Latin America,” in "), _c('i', [_vm._v("Oxford History of the British Empire")]), _vm._v(", vol. 3, "), _c('i', [_vm._v("The Nineteenth Century")]), _vm._v(", ed. William Roger Lewis and Andrew Porter (New York: Oxford University Press, 1999), 141–42.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en110r",
      "id": "en110"
    }
  }, [_vm._v("110.")]), _vm._v(" For an excellent overview, and for the quoted passage, see Knight, “Britain and Latin America.” See also the classic formulation in Gallagher and Robinson, “The Imperialism of Free Trade.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en111r",
      "id": "en111"
    }
  }, [_vm._v("111.")]), _vm._v(" Thomas Campbell-Copeland, "), _c('i', [_vm._v("American Colonial Handbook: A Ready Reference Book of Facts and Figures, Historical, Geographical, and Commercial, about Cuba, Puerto Rico, the Philippines, Hawaii, and Guam")]), _vm._v(", 2nd ed. (New York, 1899); José de Olivares and William Smith Bryan, "), _c('i', [_vm._v("Our Islands and Their People, as Seen with Camera and Pencil")]), _vm._v(" (St. Louis: N. D. Thompson, 1899).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en112r",
      "id": "en112"
    }
  }, [_vm._v("112.")]), _vm._v(" On seeing the era as one of early globalization, see Anderson, "), _c('i', [_vm._v("Under Three Flags")]), _vm._v(" (n. 13 above), passim; Maier, “Leviathan 2.0” (n. 50 above), 211–29, who discusses the case of Mexico comparatively; and Hobsbawm, "), _c('i', [_vm._v("Age of Empire: 1875–1914")]), _vm._v(" (New York: Vintage, 1989).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en113r",
      "id": "en113"
    }
  }, [_vm._v("113.")]), _vm._v(" My suggestion here is not that the revolution was first and foremost an anti-imperial uprising. The debate around the causes of the revolution is sharp. For a perspective that stresses anti-imperialist aspects, see John Hart, "), _c('i', [_vm._v("Revolutionary Mexico: The Coming and Process of the Mexican Revolution")]), _vm._v(" (Berkeley: University of California Press, 1987); for an analysis that stresses largely the internal and agrarian roots of the revolution, and one which I find persuasive, see Alan Knight, "), _c('i', [_vm._v("The Mexican Revolution")]), _vm._v(", 2 vols. (Lincoln: University of Nebraska Press, 1986). For an excellent collection that works between these poles, in many cases by taking up regional examples, see Daniel Nugent, ed., "), _c('i', [_vm._v("Rural Revolt in Mexico: U.S. Intervention and the Domain of Subaltern Politics")]), _vm._v(" (Durham: Duke University Press, 1998); as well as Gilbert M. Joseph, "), _c('i', [_vm._v("Revolution from Without: Yucatán, Mexico and the United States, 1880–1924")]), _vm._v(" (Cambridge: Cambridge University Press, 1982).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en114r",
      "id": "en114"
    }
  }, [_vm._v("114.")]), _vm._v(" See Craib, "), _c('i', [_vm._v("Cartographic Mexico")]), _vm._v(" (n. 47 above), chap. 7; Craib, “The Archive in the Field: Document, Discourse and Space in Mexico’s Agrarian Reform,” "), _c('i', [_vm._v("Journal of Historical Geography")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p69"
    }
  }), _vm._v("36 (October 2010): 411–20; Michael Ervin, “Statistics, Maps and Legibility: Negotiating Nationalism in Post-revolutionary Mexico,” "), _c('i', [_vm._v("Americas")]), _vm._v(" 66, no. 2 (2009): 155–79; Ervin, “The Art of the Possible: Agronomists, Agrarian Reform, and the Middle Politics of the Mexican Revolution, 1908–1934” (Ph.D. dissertation, University of Pittsburgh, 2002); and Catherine Nolan-Ferrell, “Agrarian Reform and Revolutionary Justice in Soconusco, Chiapas: Campesinos and the Mexican State, 1934–1940,” "), _c('i', [_vm._v("Journal of Latin American Studies")]), _vm._v(" 42, no. 3 (2010): 551–85.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en115r",
      "id": "en115"
    }
  }, [_vm._v("115.")]), _vm._v(" On economic dependency and national liberation in Latin America in the mid-twentieth century, see Mallon, “Pathways to Postcolonial Nationhood” (n. 56 above), 274–75.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en116r",
      "id": "en116"
    }
  }, [_vm._v("116.")]), _vm._v(" Grandin, "), _c('i', [_vm._v("The Last Colonial Massacre")]), _vm._v(" (n. 12 above); “Palabras de la Revolución Nacional, Dr. Victor Paz Estenssoro” (August 2, 1953), in "), _c('i', [_vm._v("El libro blanco de la Reforma Agraria")]), _vm._v(" (La Paz: Subsecretaria de Prensa, Informaciones, y Cultura, 1953), 123–24.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en117r",
      "id": "en117"
    }
  }, [_vm._v("117.")]), _vm._v(" Prashad, "), _c('i', [_vm._v("The Darker Nations")]), _vm._v(" (n. 13 above), 19–21; Young, "), _c('i', [_vm._v("Postcolonialism")]), _vm._v(" (n. 51 above), 176–77.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en118r",
      "id": "en118"
    }
  }, [_vm._v("118.")]), _vm._v(" Kelly and Kaplan, “My Ambition Is Much Higher Than Independence” (n. 23 above), 139; Sankaran Krishna, "), _c('i', [_vm._v("Globalization & Postcolonialism: Hegemony and Resistance in the Twenty-First Century")]), _vm._v(" (Lanham, MD.: Rowman & Littlefield, 2009), chap. 2; Hardt and Negri, "), _c('i', [_vm._v("Empire")]), _vm._v(" (n. 54 above); Karl Polanyi, "), _c('i', [_vm._v("The Great Transformation: The Political and Economic Origins of Our Time")]), _vm._v(", 2nd ed. (Boston: Beacon Press, [1944] 2001); cf. Friedrich Hayek, "), _c('i', [_vm._v("The Road to Serfdom")]), _vm._v(", 2nd ed. (London: Routledge, [1944] 2001). On the history of development see Gilbert Rist, "), _c('i', [_vm._v("The History of Development: From Western Origins to Global Faith")]), _vm._v(" (London: Zed, 1997); and James Ferguson, "), _c('i', [_vm._v("The Anti-politics Machine: “Development,” Depoliticization, and Bureaucratic Power in Lesotho")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1994).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en119r",
      "id": "en119"
    }
  }, [_vm._v("119.")]), _vm._v(" On the United States, see Grandin, "), _c('i', [_vm._v("Empire’s Workshop")]), _vm._v(", 40.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en120r",
      "id": "en120"
    }
  }, [_vm._v("120.")]), _vm._v(" Martin Lewis and Kären Wigen, "), _c('i', [_vm._v("The Myth of Continents: A Critique of Metageography")]), _vm._v(" (Berkeley: University of California Press, 1998); Hobsbawm, "), _c('i', [_vm._v("Age of Extremes")]), _vm._v(", 357; Carl Pletsch, “The Three Worlds, or the Division of Social Scientific Labor, circa 1950–1975,” "), _c('i', [_vm._v("Comparative Studies in Society and History")]), _vm._v(" 23, no. 4 (1981): 565–90; Susan Schulten, "), _c('i', [_vm._v("The Geographic Imagination in America, 1880–1950")]), _vm._v(" (Chicago: University of Chicago Press, 2001); and Prashad, "), _c('i', [_vm._v("The Darker Nations")]), _vm._v(", 6–7.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en121r",
      "id": "en121"
    }
  }, [_vm._v("121.")]), _vm._v(" On Torres-García’s map, see Jennifer Jolly, “Reordering Our World,” in "), _c('i', [_vm._v("Mapping Latin America: A Cartographic Reader")]), _vm._v(", ed. Jordana Dym and Karl Offen (Chicago: University of Chicago Press, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en122r",
      "id": "en122"
    }
  }, [_vm._v("122.")]), _vm._v(" See especially Lefebvre, "), _c('i', [_vm._v("State, Space, World")]), _vm._v(" (n. 38 above); Lefebvre, "), _c('i', [_vm._v("Critique of Everyday Life")]), _vm._v(", trans. Gregory Elliott, 3 vols. (London: Verso, [1947, 1961, 1981] 2008); Guy Debord, "), _c('i', [_vm._v("Society of the Spectacle")]), _vm._v(", trans. Donald Nicholson-Smith (New York: Zone Books, [1967] 1995); Andy Merrifield, "), _c('i', [_vm._v("Henri Lefebvre: A Critical Introduction")]), _vm._v(" (New York: Routledge, 2006), 9–10; and Kristin Ross, "), _c('i', [_vm._v("Fast Cars, Clean Bodies: Decolonization and the Reordering of French Culture")]), _vm._v(" (Cambridge, MA: MIT Press, 1995).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en123r",
      "id": "en123"
    }
  }, [_vm._v("123.")]), _vm._v(" Lefebvre, “Theoretical Problems of "), _c('i', [_vm._v("Autogestion")]), _vm._v(",” in Lefebvre, "), _c('i', [_vm._v("State, Space, World")]), _vm._v(", chap. 5.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en124r",
      "id": "en124"
    }
  }, [_vm._v("124.")]), _vm._v(" David Pinder, “Subverting Cartography: Situationists and Maps of the City,” "), _c('i', [_vm._v("Environment and Planning A")]), _vm._v(" 28 (1996): 405–27, quoted passage on 419. Also useful here, for comparison and to extend the argument, is Tim Ingold, "), _c('i', [_vm._v("The Perception of the Environment")]), _vm._v(", rev. ed. (London: Routledge, 2011), esp. pt. II.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en125r",
      "id": "en125"
    }
  }, [_vm._v("125.")]), _vm._v(" Simon Sadler, "), _c('i', [_vm._v("The Situationist City")]), _vm._v(" (Cambridge, MA: MIT Press, 1999), 82. More generally see Michel de Certeau, "), _c('i', [_vm._v("The Practice of Everyday Life")]), _vm._v(", trans. Donald Nicholson-Smith "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p70"
    }
  }), _vm._v("(Berkeley: University of California Press, 1994); and Abdelhafid Khatib, “Attempt at a Psychogeographical Description of Les Halles,” trans. Paul Hammond, originally published in "), _c('i', [_vm._v("Internationale Situationniste")]), _vm._v(", no. 2 (1958), available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.cddc.vt.edu/sionline/si/lehalles.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.cddc.vt.edu/sionline/si/lehalles.html")]), _vm._v(" (last accessed on June 1, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en126r",
      "id": "en126"
    }
  }, [_vm._v("126.")]), _vm._v(" The relationship between the grid and capitalism is examined with real brilliance, if not always in the exact way I have cast it here, by Denis Cosgrove, “Prospect, Perspective and the Evolution of the Landscape Idea,” "), _c('i', [_vm._v("Transactions of the Institute of British Geographers")]), _vm._v(" 10, no. 1 (1985): 45–62; Brian Rotman, "), _c('i', [_vm._v("Signifying Nothing: The Semiotics of Zero")]), _vm._v(" (Palo Alto: Stanford University Press, 1993); and Ken Hillis, “The Power of Disembodied Imagination: Perspective’s Role in Cartography,” "), _c('i', [_vm._v("Cartographica")]), _vm._v(" 31, no. 3 (1994): 1–17.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en127r",
      "id": "en127"
    }
  }, [_vm._v("127.")]), _vm._v(" See especially Dirlik, "), _c('i', [_vm._v("The Postcolonial Aura")]), _vm._v(" (n. 29 above), 54. See also Brennan, “The Image-Function of the Periphery” (n. 106 above); and Masao Miyoshi, “A Borderless World? From Colonialism to Transnationalism and the Decline of the Nation-State,” "), _c('i', [_vm._v("Critical Inquiry")]), _vm._v(" 19, no. 4 (1993): 726–51.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en128r",
      "id": "en128"
    }
  }, [_vm._v("128.")]), _vm._v(" I say “purported” because the Cold War was anything but in much of the global south: the experiences of Vietnam, Guatemala, Iran, Chile, and El Salvador, among others, are evidence enough of the murderousness of the Cold War in some locales.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en129r",
      "id": "en129"
    }
  }, [_vm._v("129.")]), _vm._v(" "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.hawaii.edu/cpis/oceania_1.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.hawaii.edu/cpis/oceania_1.html")]), _vm._v(" (accessed January 25, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en130r",
      "id": "en130"
    }
  }, [_vm._v("130.")]), _vm._v(" Francis Fukuyama, "), _c('i', [_vm._v("The End of History and the Last Man")]), _vm._v(" (New York: Harper Perennial, 1993). For a powerful counter to liberal triumphalism, see Domenico Losurdo, "), _c('i', [_vm._v("Liberalism: A Counter-history")]), _vm._v(", trans. Gregory Elliott (London: Verso, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en131r",
      "id": "en131"
    }
  }, [_vm._v("131.")]), _vm._v(" See the useful discussion in Richard Warren Perry, “Rebooting the World Picture: Flying Windows of Globalization in the End of Times,” in "), _c('i', [_vm._v("Globalization under Construction: Governmentality, Law and Identity")]), _vm._v(", ed. Richard Warren Perry and Bill Maurer (Minneapolis: University of Minnesota Press, 2003), 324; and Debbie Lisle, "), _c('i', [_vm._v("The Global Politics of Contemporary Travel Writing")]), _vm._v(" (Cambridge: Cambridge University Press, 2006), 234–35.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en132r",
      "id": "en132"
    }
  }, [_vm._v("132.")]), _vm._v(" John Pickles, “New Cartographies and the Decolonization of European Geographies,” "), _c('i', [_vm._v("Area")]), _vm._v(" 37, no. 4 (2005): 355–64, cited passage on 359–60. The degree to which one can call the former USSR a “colonial power” is questionable. See Sharad Chari and Katherine Verdery, “Thinking between the Posts: Postcolonialism, Postsocialism and Ethnography After the Cold War,” "), _c('i', [_vm._v("Comparative Studies in Society and History")]), _vm._v(" 51, no. 1 (January 2009): 6–34.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en133r",
      "id": "en133"
    }
  }, [_vm._v("133.")]), _vm._v(" Katherine Verdery, "), _c('i', [_vm._v("The Vanishing Hectare: Property and Value in Postsocialist Transylvania")]), _vm._v(" (Ithaca, NY: Cornell University Press, 2003), 3–4; see also Jessica Allina-Pisano, "), _c('i', [_vm._v("The Post-Soviet Potemkin Village: Politics and Property Rights in the Black Earth")]), _vm._v(" (Cambridge: Cambridge University Press, 2008); and Chari and Verdery, “Thinking between the Posts.”")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en134r",
      "id": "en134"
    }
  }, [_vm._v("134.")]), _vm._v(" Discrete cartographies—based on national or ethnic origin—are now deployed rhetorically to celebrate “multiculturalism,” which seem in part a useful means for masking the dramatic transfers of wealth and power into the hands of “borderless” transnational corporations. Most recently see the insightful analysis of Nicholas Shaxson, "), _c('i', [_vm._v("Treasure Islands: Tax Havens and the Men Who Stole the World")]), _vm._v(" (London: Bodley Head, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en135r",
      "id": "en135"
    }
  }, [_vm._v("135.")]), _vm._v(" "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://news.bbc.co.uk/2/hi/business/8208254.stm",
      "target": "_blank"
    }
  }, [_vm._v("http://news.bbc.co.uk/2/hi/business/8208254.stm")]), _vm._v(". More broadly worth consideration here is the current epoch of land grabbing. See, for a useful introduction, Fred Pearce, "), _c('i', [_vm._v("The Land Grabbers: The New Fight over Who Owns the Earth")]), _vm._v(" (Boston: Beacon, 2012).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en136r",
      "id": "en136"
    }
  }, [_vm._v("136.")]), _vm._v(" See the devastaing and succinct analysis in Mike Davis and Daniel Bertrand Monk, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p71"
    }
  }), _vm._v("“Introduction,” in "), _c('i', [_vm._v("Evil Paradises: Dreamworlds of Neoliberalism")]), _vm._v(", ed. Davis and Monk (New York: New Press, 2007); and Timothy Mitchell, “Dreamland,” in ibid.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en137r",
      "id": "en137"
    }
  }, [_vm._v("137.")]), _vm._v(" See Hardt and Negri, "), _c('i', [_vm._v("Empire")]), _vm._v("; Joseph E. Stiglitz, "), _c('i', [_vm._v("Globalization and Its Discontents")]), _vm._v(" (New York: W. W. Norton, 2002). For “Operation Adam Smith,” see Grandin, "), _c('i', [_vm._v("Empire’s Workshop")]), _vm._v(" (n. 107 above), 160.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en138r",
      "id": "en138"
    }
  }, [_vm._v("138.")]), _vm._v(" Lewis Hyde, "), _c('i', [_vm._v("Common as Air: Revolution, Art and Ownership")]), _vm._v(" (New York: Farrar, Straus & Giroux, 2010), 17; Edward D. Melillo, “Spectral Frequencies: Neoliberal Enclosures of the Electromagnetic Commons,” "), _c('i', [_vm._v("Radical History Review")]), _vm._v(" 112 (Winter 2012): 147–61.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en139r",
      "id": "en139"
    }
  }, [_vm._v("139.")]), _vm._v(" Robert Kaplan, "), _c('i', [_vm._v("The Revenge of Geography")]), _vm._v("; Wainwright, "), _c('i', [_vm._v("Geo-piracy")]), _vm._v(" (no. 78 above); Craib, “The Properties of Counterinsurgency: On Joel Wainwright’s "), _c('i', [_vm._v("Geo-piracy")]), _vm._v(",” "), _c('i', [_vm._v("Dialogues in Human Geography")]), _vm._v(" 4, no. 1 (March 2014): 86–91; and Jeremy Crampton, "), _c('i', [_vm._v("Mapping: A Critical Introduction to Cartography and GIS")]), _vm._v(" (Oxford: Wiley Blackwell, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en140r",
      "id": "en140"
    }
  }, [_vm._v("140.")]), _vm._v(" For an excellent collection, Liz Mogel and Alexis Bhagat, eds., "), _c('i', [_vm._v("An Atlas of Radical Cartography")]), _vm._v(" (Los Angeles: Journal of Aesthetics & Protest Press, 2008). On hackitectura, see Sebastián Cobarrubias and John Pickles, “Spacing Movements: The Turn to Cartography and Mapping Practices in Contemporary Social Movements,” in "), _c('i', [_vm._v("The Spatial Turn: Interdisciplinary Perspectives")]), _vm._v(", ed. Barney Warf and Santa Arias (New York: Routledge, 2009), 36–58; and "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.hackitectura.net",
      "target": "_blank"
    }
  }, [_vm._v("www.hackitectura.net")]), _vm._v(" (last accessed June 29, 2011).")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en141r",
      "id": "en141"
    }
  }, [_vm._v("141.")]), _vm._v(" Craig Dalton and Liz Mason-Deese, “Counter (Mapping) Actions: Mapping as Militant Research,” "), _c('i', [_vm._v("ACME: An International E-Journal for Critical Geographies")]), _vm._v(" 11, no. 3 (2012): 439–66, quoted text on 440.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en142r",
      "id": "en142"
    }
  }, [_vm._v("142.")]), _vm._v(" Jeremy Crampton and John Krygier, “An Introduction to Critical Cartography,” "), _c('i', [_vm._v("ACME: An International E-Journal for Critical Geographies")]), _vm._v(" 14, no. 1 (2006): 11–33.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en143r",
      "id": "en143"
    }
  }, [_vm._v("143.")]), _vm._v(" I am indebted to Sumathi Ramaswamy for raising this point with me.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en144r",
      "id": "en144"
    }
  }, [_vm._v("144.")]), _vm._v(" "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.sasi.group.shef.ac.uk/worldmapper/display.php?selected=162",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sasi.group.shef.ac.uk/worldmapper/display.php?selected=162")]), _vm._v(". These are maps that put into visual form the historical evidence marshaled by critics of modernization theory and developmentalist theorists, critics such as Raul Prebisch, who noted explicitly the "), _c('i', [_vm._v("longue durée")]), _vm._v(" of historical change in income inequality and distribution in formulating his import substitution industrialization policies. See Prashad, "), _c('i', [_vm._v("The Darker Nations")]), _vm._v(" (n. 13 above), 66–67. For an insightful discussion of how economists and historians have debated the history of wealth extraction under imperial rule and, therefore, the validity of dependency theory, see Brennan, “The Image-Function of the Periphery,” 108–11.")])]), _vm._v(" "), _c('div', {
    staticClass: "endnote"
  }, [_c('p', {
    staticClass: "en"
  }, [_c('a', {
    staticClass: "ennum",
    attrs: {
      "href": "#/chiAkerman0009#en145r",
      "id": "en145"
    }
  }, [_vm._v("145.")]), _vm._v(" “The New Enclosures,” "), _c('i', [_vm._v("Midnight Notes Collective")]), _vm._v(" 10 (1990): 3, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.midnightnotes.org/pdfnewenc1.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.midnightnotes.org/pdfnewenc1.pdf")]), _vm._v(" (last accessed March 5, 2015).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0a9dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Akerman-0009.vue
// module id = 78
// module chunks = 0